<template>
  <div class="kit-material-workbench ord-suite-detail-view" v-loading="initialLoading">
    <!-- 齐料情况过滤与操作条 -->
    <section v-if="!toolbarInTabs" class="query-band" aria-label="订单齐套查询条件">
      <nav class="dimension-nav" aria-label="齐套分析维度">
        <div class="dimension-tabs">
          <div class="readiness-filter-group" data-ui="toggle-group" role="group" aria-label="齐料情况筛选">
            <button
              type="button"
              class="readiness-chip all"
              :class="{ 'is-active': summaryFilters.readinessFilter === 'all' }"
              @click="setReadinessFilter('all')">
              全部 {{ readinessSummary.total }}
            </button>
            <button
              type="button"
              class="readiness-chip ready"
              :class="{ 'is-active': summaryFilters.readinessFilter === 'ready' }"
              @click="setReadinessFilter('ready')">
              已齐套 {{ readinessSummary.ready }}
            </button>
            <button
              type="button"
              class="readiness-chip partial"
              :class="{ 'is-active': summaryFilters.readinessFilter === 'partial' }"
              @click="setReadinessFilter('partial')">
              部分齐料 {{ readinessSummary.partial }}
            </button>
            <button
              type="button"
              class="readiness-chip shortage"
              :class="{ 'is-active': summaryFilters.readinessFilter === 'shortage' }"
              @click="setReadinessFilter('shortage')">
              未齐套 {{ readinessSummary.shortage }}
            </button>
          </div>
        </div>
        <div class="dimension-nav-actions">
          <span v-if="suiteLoaded" class="data-snapshot-hint">数据快照于 {{ dataSnapshotAt }}</span>
          <el-button class="shadcn-button shadcn-button--ghost" size="mini" icon="el-icon-refresh" :loading="suiteLoading" @click="loadSuiteData(true)">刷新</el-button>
        </div>
      </nav>
    </section>

    <!-- 上栏：订单齐套汇总表格 -->
    <section class="pane upper-pane" :style="{ height: upperHeight + 'px' }" aria-label="订单齐套汇总">
      <div class="table-wrap">
        <el-table
          ref="summaryTable"
          class="summary-table shadcn-data-table"
          style="width: 100%;"
          :fit="true"
          data-ui="data-table"
          v-loading="suiteLoading"
          :data="filteredSummary"
          border
          highlight-current-row
          height="100%"
          :row-style="summaryRowStyle"
          :row-key="summaryRowKey"
          @row-click="selectSummaryRow"
          @header-dragend="handleSummaryColumnResize">
          <el-table-column type="index" width="46" fixed align="center">
            <template v-slot:header>
              <el-tooltip content="重置全部筛选" placement="top">
                <el-button class="summary-filter-reset" type="text" icon="el-icon-delete-solid" aria-label="重置全部筛选" @click.stop="resetSummaryFilters"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column v-for="column in summaryColumns" :key="column.key + '-' + column.width + '-' + column.fixed"
            :label="column.title" :min-width="column.width" :align="column.align" :fixed="column.fixed">
            <el-table-column :prop="column.prop" :column-key="column.key" :min-width="column.width"
              :align="column.align" show-overflow-tooltip>
              <template v-slot:header>
                <el-input v-if="['orderNo', 'clientCode', 'sku', 'productName', 'model'].includes(column.prop)"
                v-model="summaryFilters[column.prop]" class="summary-header-filter" size="mini" clearable
                placeholder="" @input="handleSummaryFilterChange"></el-input>
                <template v-else-if="column.prop === 'qty'">
                  <el-input v-model="summaryFilters.qty" class="summary-header-filter" size="mini" clearable type="number" placeholder="" @input="handleSummaryFilterChange"></el-input>
                </template>
                <template v-else-if="column.prop === 'deliveryDate'">
                  <el-date-picker v-model="summaryFilters.deliveryDate" class="summary-header-filter" size="mini" type="date" clearable value-format="yyyy-MM-dd" placeholder="" @change="commitSummaryFilters"></el-date-picker>
                </template>
                <template v-else-if="column.prop === 'orderStatus'">
                  <el-select v-model="summaryFilters.orderStatus" class="summary-header-filter" size="mini" clearable placeholder="" @change="commitSummaryFilters">
                    <el-option label="生产中" value="生产中"></el-option>
                    <el-option label="已排产" value="已排产"></el-option>
                    <el-option label="待排产" value="待排产"></el-option>
                  </el-select>
                </template>
                <template v-else-if="column.prop === 'priority'">
                  <el-select v-model="summaryFilters.priority" class="summary-header-filter" size="mini" clearable placeholder="" @change="commitSummaryFilters">
                    <el-option label="紧急" value="紧急"></el-option>
                    <el-option label="高" value="高"></el-option>
                    <el-option label="普通" value="普通"></el-option>
                  </el-select>
                </template>
                <template v-else-if="column.prop === 'readiness'">
                  <el-select v-model="summaryFilters.readiness" class="summary-header-filter" size="mini" clearable placeholder="" @change="commitSummaryFilters">
                    <el-option label="已齐套" value="已齐套"></el-option>
                    <el-option label="部分齐料" value="部分齐料"></el-option>
                    <el-option label="未齐套" value="未齐套"></el-option>
                  </el-select>
                </template>
                <template v-else-if="column.prop === 'expectedReadyDate'">
                  <el-date-picker v-model="summaryFilters.expectedReadyDate" class="summary-header-filter" size="mini" type="date" clearable value-format="yyyy-MM-dd" placeholder="" @change="commitSummaryFilters"></el-date-picker>
                </template>
                <template v-else-if="column.prop === 'startDate'">
                  <el-date-picker v-model="summaryFilters.startDate" class="summary-header-filter" size="mini" type="date" clearable value-format="yyyy-MM-dd" placeholder="" @change="commitSummaryFilters"></el-date-picker>
                </template>
                <template v-else-if="column.prop === 'delayDays'">
                  <el-input v-model="summaryFilters.delayDays" class="summary-header-filter" size="mini" clearable type="number" placeholder="" @input="handleSummaryFilterChange"></el-input>
                </template>
                <template v-else-if="column.prop === 'shortageCount'">
                  <el-select v-model="summaryFilters.shortageState" class="summary-header-filter" size="mini" clearable placeholder="" @change="commitSummaryFilters">
                    <el-option label="有欠料" value="has"></el-option>
                    <el-option label="无欠料" value="none"></el-option>
                  </el-select>
                </template>
              </template>
              <template slot-scope="scope">
                <template v-if="column.prop === 'orderStatus'">
                  <el-tag v-if="scope.row.orderStatus" data-ui="badge" size="mini" effect="plain" :type="scope.row.orderStatus === '生产中' ? 'success' : scope.row.orderStatus === '待排产' ? 'warning' : 'info'">{{ scope.row.orderStatus }}</el-tag>
                </template>
                <template v-else-if="column.prop === 'priority'">
                  <span>
                    <i v-if="scope.row.priority" class="priority-dot" :class="priorityClass(scope.row.priority)"></i>{{ scope.row.priority }}
                  </span>
                </template>
                <template v-else-if="column.prop === 'readiness'">
                  <div class="readiness-cell" :class="readinessClass(scope.row.readiness)" :title="scope.row.shortMatDesc || ''">
                    <div class="readiness-bar">
                      <span class="readiness-bar-fill" :style="{ width: (scope.row.readinessRate == null ? 0 : scope.row.readinessRate) + '%' }"></span>
                      <span v-if="scope.row.readinessRate != null" class="readiness-bar-text">{{ scope.row.readinessRate }}%</span>
                    </div>
                  </div>
                </template>
                <template v-else-if="column.prop === 'kitQty'"><span>{{ scope.row.kitQty }}</span></template>
                <template v-else-if="column.prop === 'materialTotalCount'"><span>{{ scope.row.materialTotalCount }}</span></template>
                <template v-else-if="column.prop === 'delayDays'">
                  <span :class="scope.row.delayDays > 0 ? 'danger-text' : ''">{{ scope.row.delayDays == null ? '' : scope.row.delayDays + '天' }}</span>
                </template>
                <template v-else-if="column.prop === 'shortageCount'">
                  <span :class="scope.row.shortageCount ? 'danger-text' : 'success-text'">{{ scope.row.shortageCount }}</span>
                </template>
                <span v-else>{{ summaryColumnValue(scope.row, column) }}</span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </section>

    <!-- 分割拖拽条 -->
    <div class="splitter" title="拖动调整上下表格高度" @mousedown="startResize"></div>

    <!-- 下栏：物料齐套明细工作区 -->
    <section class="pane lower-pane" aria-label="物料齐套明细">
      <!-- 物料操作栏 -->
      <div class="material-workbar">
        <span class="material-section-title">净物料</span>

        <div class="selected-sku-context" :title="selectedSkuLabel">
          {{ selectedSkuLabel || '未选择 SKU' }}
        </div>

        <el-input v-model="materialSearch" class="material-quick-search" size="mini" clearable
          prefix-icon="el-icon-search" placeholder="物料编码 / 名称 / 描述 / 数量"
          aria-label="搜索物料编码、物料名称、描述或数量" @input="handleMaterialSearch"
          @clear="commitMaterialSearch" @keyup.enter.native="commitMaterialSearch" />
        <div class="material-state-filter" data-ui="toggle-group" role="group" aria-label="物料状态筛选">
          <button type="button" class="state-filter-button" :class="{ 'is-active': materialStateFilter === 'all' }" @click="setMaterialStateFilter('all')">全部 {{ materialStateCounts.all }}</button>
          <button type="button" class="state-filter-button shortage" :class="{ 'is-active': materialStateFilter === 'shortage' }" @click="setMaterialStateFilter('shortage')">欠料 {{ materialStateCounts.shortage }}</button>
          <button type="button" class="state-filter-button normal" :class="{ 'is-active': materialStateFilter === 'normal' }" @click="setMaterialStateFilter('normal')">正常 {{ materialStateCounts.normal }}</button>
        </div>

        <div class="selection-actions">
          <el-button class="shadcn-button shadcn-button--outline" size="mini" title="追踪" :disabled="selectedMaterials.length === 0" @click="openSelectedLocation">
            <span class="selection-action-label">追踪{{ selectedMaterials.length ? ` (${selectedMaterials.length})` : '' }}</span>
          </el-button>
          <el-button v-if="selectedMaterials.length > 0" class="shadcn-button shadcn-button--ghost" size="mini" title="清空所选" @click="clearNetMaterialSelection">
            清空
          </el-button>
        </div>
      </div>

      <div v-if="materialQueryError" class="material-query-error" role="alert">
        <span>{{ materialQueryError }}</span>
        <el-button type="text" size="mini" icon="el-icon-refresh" @click="refreshSelectedMaterials()">重试</el-button>
      </div>

      <div v-if="materialFieldError" class="material-query-error" role="alert">
        <span>{{ materialFieldError }}</span>
        <el-button type="text" size="mini" icon="el-icon-refresh" :loading="materialFieldLoading" @click="loadMaterialFieldMetadata">重试字段加载</el-button>
      </div>

      <div v-if="materialSummaryError" class="material-query-error" role="alert">
        <span>{{ materialSummaryError }}</span>
        <el-button type="text" size="mini" icon="el-icon-refresh" :loading="materialQueryLoading" @click="refreshSelectedMaterials()">重试补充数据</el-button>
      </div>
      <div v-if="materialSummaryConflictCount" class="material-query-error material-query-warning" role="status">
        <span>请购汇总存在 {{ materialSummaryConflictCount }} 项字段冲突，未补充冲突值</span>
      </div>

      <!-- 当前 SKU 原始请购记录保留，汇总补充值仅用于动态列展示和筛选。 -->
      <div class="table-wrap" v-loading="materialQueryLoading || materialFieldLoading">
        <el-table
          ref="netMaterialTable"
          class="material-table net-material-table shadcn-data-table"
          data-ui="data-table"
          :data="filteredNetMaterials"
          height="100%"
          :row-key="materialRowKey"
          :row-class-name="materialRowClassName"
          border
          stripe
          size="mini"
          @selection-change="handleNetMaterialSelection"
          @header-dragend="handleMaterialColumnResize">
          <el-table-column v-for="column in selectionColumns"
            :key="column.key" :column-key="column.key" type="selection" :reserve-selection="true" :width="column.width" :fixed="column.fixed"
            :align="column.align" :selectable="materialSelectable"></el-table-column>

          <el-table-column label="序号" width="50" fixed align="center">
            <template v-slot:header>
              <div class="summary-header-row summary-header-title">序号</div>
              <div class="summary-header-row summary-header-search">
                <el-button class="summary-filter-reset" type="text" icon="el-icon-delete" size="mini" title="重置净物料筛选" @click="resetNetMaterialFilters"></el-button>
              </div>
            </template>
            <template slot-scope="scope"><span>{{ scope.$index + 1 }}</span></template>
          </el-table-column>

          <el-table-column
            v-for="column in displayMaterialColumns"
            :key="'mat-col-' + column.key"
            :column-key="column.key"
            :prop="column.prop"
            :label="column.title"
            :width="column.width"
            :resizable="true"
            :align="column.align"
            :fixed="column.fixed"
            show-overflow-tooltip>
            <template v-slot:header>
              <div class="summary-header-row summary-header-title" :title="column.title">{{ column.title }}</div>
              <div class="summary-header-row summary-header-search">
                <el-input
                  v-model="netMaterialFilters[column.prop]"
                  class="summary-header-filter"
                  size="mini"
                  clearable
                  placeholder=""
                  @input="handleMaterialFilterChange">
                </el-input>
              </div>
            </template>
            <template slot-scope="scope">
              <div v-if="column.key === 'MATNM'" class="material-name">
                <span>{{ materialColumnValue(scope.row, column.key) }}</span>
              </div>
              <span v-else>
                {{ materialColumnValue(scope.row, column.key) }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="110" fixed="right" align="center">
            <template v-slot:header>
              <div class="summary-header-row summary-header-title">操作</div>
              <div class="summary-header-row summary-header-search"></div>
            </template>
            <template slot-scope="scope">
              <div class="material-operation-actions">
                <button
                  class="table-link"
                  :disabled="!permissions.lock || !canLockRow(scope.row)"
                  :title="!permissions.lock ? '无锁库权限' : (!canLockRow(scope.row) ? '非真实原材料不可锁库' : '仓存锁库')"
                  @click.stop="openSingleMaterialLock(scope.row)">
                  锁库
                </button>
                <button class="table-link" @click="openSupplyTrace(scope.row)">追踪</button>
              </div>
            </template>
          </el-table-column>
        </el-table>


      </div>
    </section>

    <el-dialog
      title="物料仓存锁库与释放"
      custom-class="kit-dialog material-lock-dialog"
      :visible.sync="erpLockDialogVisible"
      width="1120px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="!erpLockWriting"
      :show-close="!erpLockWriting"
      @close="handleErpLockDialogClose">
      <div class="material-lock-content-scroll">
        <!-- 待锁物料列表 -->
        <section aria-label="所选锁库物料" class="material-lock-section">
          <el-table :data="erpLockContexts" border size="mini" :row-key="lockContextRowKey" highlight-current-row @row-click="handleErpLockContextClick">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="matNo" label="物料编码" width="112"></el-table-column>
            <el-table-column prop="matName" label="物料名称" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="demandQty" label="需求数量" width="86" align="right"></el-table-column>
            <el-table-column prop="availableQty" label="当前可用量" width="96" align="right">
              <template slot-scope="scope"><strong class="success-text">{{ scope.row.availableQty }}</strong></template>
            </el-table-column>
            <el-table-column prop="lockedQty" label="累计已锁" width="86" align="right"></el-table-column>
            <el-table-column prop="remainingQty" label="剩余待锁" width="86" align="right"></el-table-column>
          </el-table>
        </section>

        <!-- 仓库可用库存分配 -->
        <section aria-label="可用库存" class="material-lock-section">
          <div class="material-lock-section-head">
            <div><strong>可用库存</strong><span>（{{ activeErpLockContext ? activeErpLockContext.matNo : '' }}）仓库可用库存分配</span></div>
            <el-button type="text" size="mini" icon="el-icon-refresh" :disabled="erpLockWriting" @click="refreshErpLockData">刷新库存</el-button>
          </div>
          <el-table v-loading="erpLockLoading" :data="erpLockStockRows" border size="mini" max-height="200" empty-text="暂无可用库存">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="STKNM" label="仓库名称" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="LOTNO" label="批次号" min-width="108" show-overflow-tooltip></el-table-column>
            <el-table-column prop="QTY" label="库存现存量" width="96" align="right"></el-table-column>
            <el-table-column prop="OKQTY" label="当前可用量" width="96" align="right">
              <template slot-scope="scope"><strong class="success-text">{{ scope.row.OKQTY }}</strong></template>
            </el-table-column>
            <el-table-column label="分配数量" width="140" align="center">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.ALLOQTY" size="mini" type="number" :min="0" :max="scope.row.OKQTY" :disabled="erpLockWriting" placeholder="输入数量"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="82" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="mini" icon="el-icon-lock" :disabled="erpLockWriting || !scope.row.ALLOQTY || scope.row.ALLOQTY <= 0" @click="allocateErpLock(scope.row)">分配</el-button>
              </template>
            </el-table-column>
          </el-table>
        </section>

        <!-- 已锁库明细 -->
        <section aria-label="已锁库明细" class="material-lock-section">
          <div class="material-lock-section-head">
            <div><strong>已锁库明细</strong><span>当前需求行已锁定的仓存明细</span></div>
          </div>
          <el-table v-loading="erpLockLoading" :data="erpLockLockedRows" border size="mini" max-height="180" empty-text="暂无锁库明细">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="STKNM" label="锁定仓库" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="LOTNO" label="锁定批次" min-width="108" show-overflow-tooltip></el-table-column>
            <el-table-column prop="QTY" label="锁定数量" width="96" align="right"></el-table-column>
            <el-table-column prop="ADDUSER" label="锁定人" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="ADDDTTM" label="锁定时间" min-width="146" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="92" align="center">
              <template slot-scope="scope">
                <el-button class="danger-text" type="text" size="mini" icon="el-icon-unlock" :disabled="erpLockWriting" @click="releaseErpLock(scope.row)">整条释放</el-button>
              </template>
            </el-table-column>
          </el-table>
        </section>
      </div>
      <span slot="footer">
        <el-button class="shadcn-button shadcn-button--outline" size="small" :disabled="erpLockWriting" @click="erpLockDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 抽屉：物料位置状态与供给追踪 -->
    <el-drawer
      :title="locationTitle"
      custom-class="kit-drawer"
      :visible.sync="locationDrawer"
      append-to-body
      :size="locationMode === 'multiple' ? '960px' : '640px'"
      @close="closeSupplyTrace">
      <div class="drawer-body" v-loading="supplyTraceLoading">
        <div v-if="supplyTraceError" class="material-query-error" role="alert">{{ supplyTraceError }}</div>
        <div class="location-summary">
          <div><strong>{{ locationTotals.available }}</strong><span>可用库存</span></div>
          <div><strong>{{ locationTotals.transit }}</strong><span>在途数量</span></div>
          <div><strong>{{ locationTotals.allocated }}</strong><span>订单占用</span></div>
        </div>
        <div v-if="locationMode === 'multiple'" class="drawer-section">
          <h3 class="drawer-heading">物料最新情况</h3>
          <el-table :data="locationOverviewRows" border size="mini" :row-key="locationOverviewRowKey">
            <el-table-column type="index" label="序号" width="50" fixed align="center"></el-table-column>
            <el-table-column prop="matNo" label="物料编码" width="108" fixed show-overflow-tooltip></el-table-column>
            <el-table-column prop="matName" label="物料名称" min-width="126" fixed show-overflow-tooltip></el-table-column>
            <el-table-column prop="availableQty" label="可用库存" width="78" align="right"></el-table-column>
            <el-table-column prop="inTransit" label="在途" width="66" align="right"></el-table-column>
            <el-table-column prop="allocatedQty" label="订单占用" width="78" align="right"></el-table-column>
            <el-table-column prop="shortage" label="欠料" width="66" align="right">
              <template slot-scope="scope"><span :class="scope.row.shortage > 0 ? 'danger-text' : 'success-text'">{{ scope.row.shortage }}</span></template>
            </el-table-column>
            <el-table-column prop="eta" label="预计到货日" width="104"></el-table-column>
            <el-table-column prop="status" label="最新状态" width="88" align="center">
              <template slot-scope="scope"><el-tag data-ui="badge" size="mini" effect="plain" :type="scope.row.status === '欠料' ? 'danger' : 'success'">{{ scope.row.status }}</el-tag></template>
            </el-table-column>
            <el-table-column label="操作" width="66" fixed="right" align="center">
              <template slot-scope="scope"><el-button class="shadcn-button shadcn-button--ghost" type="text" size="mini" icon="el-icon-view" @click="openLocationDetail(scope.row)">详情</el-button></template>
            </el-table-column>
          </el-table>
        </div>
        <template v-else>
          <div class="drawer-section">
            <h3 class="drawer-heading">实时库存</h3>
            <el-table :data="activeMaterialLocations" border size="mini" row-key="rowKey" empty-text="暂无分仓库存记录">
              <el-table-column type="index" label="序号" width="46" align="center"></el-table-column>
              <el-table-column prop="stkName" label="仓库名称" min-width="120" show-overflow-tooltip></el-table-column>
              <el-table-column prop="lotNo" label="批次号" min-width="100" show-overflow-tooltip></el-table-column>
              <el-table-column prop="qty" label="物理库存" width="82" align="right"></el-table-column>
              <el-table-column prop="okQty" label="可用库存" width="82" align="right">
                <template slot-scope="scope"><strong class="success-text">{{ scope.row.okQty }}</strong></template>
              </el-table-column>
            </el-table>
          </div>
          <div class="drawer-section">
            <h3 class="drawer-heading">订单采购/请购在途明细</h3>
            <el-table :data="activeMaterialPoItems" border size="mini" row-key="rowKey" empty-text="暂无在途采购单">
              <el-table-column type="index" label="序号" width="46" align="center"></el-table-column>
              <el-table-column prop="poNo" label="采购单号" min-width="120" show-overflow-tooltip></el-table-column>
              <el-table-column prop="supplier" label="供应商" min-width="120" show-overflow-tooltip></el-table-column>
              <el-table-column prop="qty" label="请购数" width="70" align="right"></el-table-column>
              <el-table-column prop="inTransit" label="在途数" width="70" align="right">
                <template slot-scope="scope"><strong class="warning-text">{{ scope.row.inTransit }}</strong></template>
              </el-table-column>
              <el-table-column prop="replyDate" label="回复交期" width="100"></el-table-column>
            </el-table>
          </div>
        </template>
      </div>
    </el-drawer>

    <!-- 抽屉：单物料供给详情二级抽屉 -->
    <el-drawer :title="locationDetailTitle" custom-class="kit-drawer" :visible.sync="locationDetailDrawer" append-to-body size="640px">
      <div class="drawer-body">
        <div class="location-summary">
          <div><strong>{{ locationDetailTotals.available }}</strong><span>可用库存</span></div>
          <div><strong>{{ locationDetailTotals.transit }}</strong><span>在途数量</span></div>
          <div><strong>{{ locationDetailTotals.allocated }}</strong><span>订单占用</span></div>
        </div>
        <div class="drawer-section">
          <h3 class="drawer-heading">分仓库存分布</h3>
          <el-table :data="activeDetailLocations" border size="mini" row-key="rowKey" empty-text="暂无分仓记录">
            <el-table-column type="index" label="序号" width="46" align="center"></el-table-column>
            <el-table-column prop="stkName" label="仓库名称" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qty" label="物理库存" width="82" align="right"></el-table-column>
            <el-table-column prop="okQty" label="可用库存" width="82" align="right"></el-table-column>
          </el-table>
        </div>
        <div class="drawer-section">
          <h3 class="drawer-heading">采购在途明细</h3>
          <el-table :data="activeDetailPoItems" border size="mini" row-key="rowKey" empty-text="暂无在途记录">
            <el-table-column type="index" label="序号" width="46" align="center"></el-table-column>
            <el-table-column prop="poNo" label="采购单号" min-width="120"></el-table-column>
            <el-table-column prop="supplier" label="供应商" min-width="120"></el-table-column>
            <el-table-column prop="inTransit" label="在途数" width="70" align="right"></el-table-column>
            <el-table-column prop="replyDate" label="回复交期" width="100"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import { getTabColOrData } from '@/api/user';

// 1. 基础转换与只读快照
const DATE_PREFIX = /^(\d{4})-(\d{2})-(\d{2})/;
const EMPTY_ROWS = Object.freeze([]);
const EMPTY_MAP = Object.freeze(Object.create(null));
const frozenSnapshots = new WeakSet();

// 仅在计算完成后发布 JSON 数据快照，避免共享子记录经选择状态再次被观察。
function freezeSnapshot(value) {
  const pending = [value];
  const seen = new WeakSet();
  while (pending.length) {
    const item = pending.pop();
    if (!item || typeof item !== 'object' || seen.has(item) || frozenSnapshots.has(item)) continue;
    seen.add(item);
    Object.keys(item).forEach(key => {
      const child = item[key];
      if (child && typeof child === 'object') pending.push(child);
    });
    Object.freeze(item);
    frozenSnapshots.add(item);
  }
  return value;
}

// 基础数据转换
// 将接口字段统一转换为去除首尾空格的字符串。
function text(value) {
  return value == null ? '' : String(value).trim();
}

// 将输入转换为有限数值，非法值使用指定默认值。
function number(value, fallback) {
  const result = Number(value);
  return Number.isFinite(result) ? result : (fallback == null ? 0 : fallback);
}

// 将可选数值转换为 Number，空值或非法值返回 null。
function numberOrNull(value) {
  if (value === '' || value == null) return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}

// 按字段优先级读取首个有效数值。
function firstNumber(row, keys, fallback) {
  if (!row) return fallback == null ? 0 : fallback;
  for (let i = 0; i < keys.length; i += 1) {
    if (row[keys[i]] !== undefined && row[keys[i]] !== null && row[keys[i]] !== '') {
      return number(row[keys[i]], fallback);
    }
  }
  return fallback == null ? 0 : fallback;
}

// 将 yyyy-MM-dd 开头的日期文本转换为本地 Date。
function dateValue(val) {
  const s = text(val);
  if (!s) return null;
  const match = DATE_PREFIX.exec(s);
  if (!match) return null;
  const d = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return Number.isNaN(d.getTime()) ? null : d;
}

// 计算两个日期之间的非负自然日差。
function dateDiffDays(later, earlier) {
  const end = dateValue(later);
  const start = dateValue(earlier);
  if (!end || !start) return null;
  return Math.max(0, Math.round((end.getTime() - start.getTime()) / 86400000));
}

// 2. 订单身份与齐套模型
// 使用账套、订单主键和分录主键生成订单行唯一键。
function buildOrderKey(row) {
  const source = row || {};
  const corpid = text(source.CORPID || source.corpid);
  const idseq = text(source.IDSEQ || source.idseq);
  const lstseq = text(source.LSTSEQ || source.lstseq);
  if (!corpid || !idseq || !lstseq) return '';
  return corpid + '::' + idseq + '::' + lstseq;
}

// 根据 OKMAT、NOTMAT、ROWCNT 判定齐套状态和比例。
function calculateReadinessRate(source) {
  const okmat = Math.max(0, number(source && source.OKMAT, 0));
  const notmat = Math.max(0, number(source && source.NOTMAT, 0));
  const rowcnt = Math.max(0, number(source && source.ROWCNT, 0));
  if (rowcnt === 0) {
    return { label: '未齐套', rate: 0, tagType: 'danger', sort: 3, kitQty: 0 };
  }
  const rate = Math.min(100, Number(((okmat / rowcnt) * 100).toFixed(1)));
  if (notmat === 0 || okmat >= rowcnt || rate >= 100) {
    return { label: '已齐套', rate: 100, tagType: 'success', sort: 1, kitQty: Number((source && source.QTY) || 0) };
  }
  if (okmat > 0 && rate > 0) {
    return { label: '部分齐料', rate, tagType: 'warning', sort: 2, kitQty: 0 };
  }
  return { label: '未齐套', rate: 0, tagType: 'danger', sort: 3, kitQty: 0 };
}

// 将 V_ORD_SUITE 原始行归一化为订单汇总表模型。
function normalizeSuiteRow(row, defaultCorpid) {
  const source = row || {};
  const corpid = text(source.CORPID || defaultCorpid);
  const idseq = text(source.IDSEQ || source.idseq);
  const lstseq = text(source.LSTSEQ || source.lstseq);
  const sku = text(source.MATNO || source.sku);
  const orderNo = text(source.IDNO || source.orderNo);
  const pkid = text(source.PKID || source.pkid || [idseq, lstseq].filter(Boolean).join('-'));
  const orderKey = buildOrderKey({
    corpid: corpid || source.corpid,
    idseq: idseq || source.idseq,
    lstseq: lstseq || source.lstseq
  });
  const rowKey = orderKey || pkid;
  const deliveryDate = text(source.DELDTTM || source.deliveryDate || source.SHPDTTM);
  const expectedReadyDate = text(source.OKDTTM || source.expectedReadyDate);
  const startDate = text(source.PRDDTTM || source.startDate);
  const readiness = calculateReadinessRate(source);
  const delayDays = expectedReadyDate && startDate ? dateDiffDays(expectedReadyDate, startDate) : null;

  return Object.assign({}, source, {
    rowKey,
    orderKey,
    pkid,
    corpid,
    idseq,
    lstseq,
    sku,
    orderNo,
    clientCode: text(source.CLNTNO || source.clientCode),
    productName: text(source.MATNM || source.productName || sku),
    model: text(source.MATDESC || source.model || source.spec),
    qty: firstNumber(source, ['QTY', 'qty', 'SALEQTY'], 0),
    deliveryDate,
    expectedReadyDate,
    startDate,
    orderStatus: text(source.STFG || source.orderStatus),
    priority: text(source.PRIORITY || source.LVL || source.priority),
    readiness: readiness.label,
    readinessRate: readiness.rate,
    kitQty: readiness.kitQty,
    delayDays,
    shortageCount: Math.max(0, number(source.NOTMAT, 0)),
    materialTotalCount: Math.max(0, number(source.ROWCNT, 0)),
    shortMatDesc: text(source.RMK || source.shortMatDesc || '')
  });
}

// 归一化订单集合并限制在当前账套内。
function filterSuiteRows(rows, corpid) {
  const result = [];
  const company = text(corpid);
  const source = rows || [];
  for (let i = 0; i < source.length; i += 1) {
    const row = source[i];
    if (corpid && text((row && row.CORPID) || corpid) !== company) continue;
    result.push(normalizeSuiteRow(row, corpid));
  }
  return result;
}

// 3. 库存与采购聚合索引
// 使用物料编码和单位生成库存聚合键。
function stockKey(matNo, unit) {
  return text(matNo) + '::' + text(unit);
}

// 仅将 m 开头编码判定为可采购、可锁库的真实原材料。
function isRealMaterial(matNo) {
  const code = text(matNo).trim().toLowerCase();
  return code.startsWith('m');
}

// 4. 单 SKU 请购明细投影：保留接口字段和记录顺序，不合并物料。
function projectRequestItems(items, order) {
  const orderKey = buildOrderKey(order);
  const keys = new Set();
  return (items || []).map((raw, index) => {
    let rowKey = text(raw && raw.PKID) || [orderKey, raw && raw.IDSEQ, raw && raw.LSTSEQ, raw && raw.MATNO, index].join('::');
    if (keys.has(rowKey)) {
      console.warn('[请购明细] 检测到主键重复，自动补齐序号后缀:', rowKey, index);
      rowKey = `${rowKey}__${index}`;
    }
    keys.add(rowKey);
    return Object.assign({}, raw, { rowKey });
  });
}

const REQUEST_SUMMARY_DISPLAY_FIELDS = Object.freeze([
  'STFG', 'POSTFG', 'PONO', 'POQTY', 'POUNITNM', 'REPLYDTTM', 'POINQTY', 'STKQTY', 'STKOKQTY'
]);
const POST_STATUS = Object.freeze({
  '未开始': 'table-body-cell-class1', '进行中': 'table-body-cell-blue',
  '已完成': 'table-body-cell-green', '异常': 'table-body-cell-yellow', '加急': 'table-body-cell-red'
});
const HIDDEN_MATERIAL_FIELDS = Object.freeze(['IDNO', 'STFG']);
const STOCK_QUANTITY_FIELDS = Object.freeze(['STKQTY', 'STKOKQTY', 'LOCKQTY']);

function hasMaterialValue(value) {
  return value !== undefined && value !== null && !(typeof value === 'string' && value.trim() === '');
}

// 保持原来的字段名大小写兼容；0 和负数都是有效值。
function readMaterialFieldValue(row, key) {
  if (!row || !key) return undefined;
  if (hasMaterialValue(row[key])) return row[key];
  const lowerKey = String(key).toLowerCase();
  const prop = Object.keys(row).find(name => name.toLowerCase() === lowerKey);
  return prop === undefined ? undefined : row[prop];
}

function materialQuantity(value) {
  if (!hasMaterialValue(value) || !['number', 'string'].includes(typeof value)) return null;
  return numberOrNull(value);
}

// 库存空值统一按 0 展示、筛选和参与计算。
function stockQuantity(value) {
  const quantity = materialQuantity(value);
  return quantity == null ? 0 : quantity;
}

// 按请购净需求 REQQTY 比较库存单位下的可用库存，不再次扣减 LOCKQTY。
// 不使用毛需求 QTY、采购在途或旧 MRP NETQTY 猜测当前缺口。
function materialCoverage(read) {
  const demand = Math.max(0, stockQuantity(read('REQQTY')));
  const available = stockQuantity(read('STKOKQTY'));
  if (demand === 0) return { state: 'normal', shortage: 0 };
  const shortage = Math.max(0, demand - Math.max(0, available));
  if (shortage > 0) return { state: 'shortage', shortage };
  return { state: 'normal', shortage: 0 };
}

// 汇总视图的需求数量、分录身份不能替代当前产品行，仅生成独立的展示补充值。
function buildRequestSummaryDisplay(items, summaries, corpid, orderIdseq) {
  const groups = new Map();
  summaries.forEach(row => {
    if (text(readMaterialFieldValue(row, 'CORPID')) !== text(corpid) ||
        text(readMaterialFieldValue(row, 'ORDSEQ')) !== text(orderIdseq)) return;
    const matNo = text(readMaterialFieldValue(row, 'MATNO'));
    if (!matNo) return;
    if (!groups.has(matNo)) groups.set(matNo, []);
    groups.get(matNo).push(row);
  });
  const index = new Map();
  groups.forEach((rows, matNo) => {
    const values = Object.create(null), conflicts = [];
    REQUEST_SUMMARY_DISPLAY_FIELDS.forEach(key => {
      const candidates = rows.map(row => readMaterialFieldValue(row, key));
      if (!candidates.some(hasMaterialValue)) return;
      if (candidates.every(value => hasMaterialValue(value) && value === candidates[0])) {
        values[key] = candidates[0];
      } else {
        conflicts.push(key);
      }
    });
    index.set(matNo, { values, conflicts, rows });
  });
  const values = Object.create(null), conflicts = new Set();
  items.forEach(row => {
    const matNo = text(readMaterialFieldValue(row, 'MATNO'));
    const summary = index.get(matNo);
    if (!summary) return;
    const additions = Object.create(null);
    Object.keys(summary.values).forEach(key => {
      if (key === 'STKQTY' || key === 'STKOKQTY') {
        const unit = text(readMaterialFieldValue(row, 'UNITNM'));
        if (!unit || !summary.rows.every(item => text(readMaterialFieldValue(item, 'UNITNM')) === unit)) return;
      }
      if (!hasMaterialValue(readMaterialFieldValue(row, key))) additions[key] = summary.values[key];
    });
    summary.conflicts.forEach(key => {
      if (!hasMaterialValue(readMaterialFieldValue(row, key))) conflicts.add(JSON.stringify([matNo, key]));
    });
    values[row.rowKey] = additions;
  });
  return { values, conflictCount: conflicts.size };
}

// 5. 直接按当前订单产品分录查询请购明细，不依赖 MRP 标志或版本。
async function loadSkuMaterials(vm, row, corpid) {
  if (!row || Array.isArray(row)) return EMPTY_ROWS;
  const company = text(corpid || vm.assemblyCorpid());
  const order = Object.assign({}, row, { CORPID: company });
  const idseq = text(row.IDSEQ || row.idseq);
  const lstseq = text(row.LSTSEQ || row.lstseq);
  if (!company || !idseq || !lstseq) throw new Error('缺少账套或订单行身份');
  const items = await vm.getItemData(idseq, lstseq, '', company);
  return projectRequestItems(items, order);
}

// 供给抽屉复用选中的订单产品请购明细，仅独立查询库存，不写回原记录。
async function loadMaterialSupply(vm, sourceRows, corpid) {
  const targets = new Map();
  sourceRows.forEach(row => {
    const matNo = text(row.MATNO);
    if (!isRealMaterial(matNo)) return;
    if (!targets.has(matNo)) targets.set(matNo, []);
    targets.get(matNo).push(row);
  });
  const entries = Array.from(targets.entries());
  const results = new Array(entries.length);
  let cursor = 0;
  const display = value => hasMaterialValue(value) ? value : '';
  const sum = (rows, field) => {
    let total = 0;
    for (const row of rows) {
      const value = materialQuantity(readMaterialFieldValue(row, field));
      if (field === 'REQQTY') total += Math.max(0, value || 0);
      else if (field === 'OKQTY' || field === 'LOCKQTY') total += value || 0;
      else {
        if (value == null) return null;
        total += value;
      }
    }
    return total;
  };
  const unitOf = row => text(row.UNITNM || row.BOMUNITNM);
  await Promise.all(Array.from({ length: Math.min(4, entries.length) }, async () => {
    while (cursor < entries.length) {
      const index = cursor++;
      const [matNo, items] = entries[index];
      const stockResponse = await getTabColOrData('xuper_auth/getTableRecMany', 'V_IC_STKLOG', 'corpid', corpid, 'matno', matNo, '', '', ' order by STKNM desc');
      const stocks = extractRows(stockResponse, '读取物料库存失败');
      const units = Array.from(new Set(items.concat(stocks).map(unitOf)));
      results[index] = units.map(unit => {
        const materialItems = items.filter(row => unitOf(row) === unit);
        const stockItems = stocks.filter(row => unitOf(row) === unit);
        const poItems = materialItems;
        const availableQty = sum(stockItems, 'OKQTY');
        // 同物料、同单位的需求合计后只使用一次库存，状态与抽屉最新库存一致。
        const supply = {
          REQQTY: sum(materialItems, 'REQQTY'),
          STKOKQTY: availableQty
        };
        const coverage = materialCoverage(key => supply[key]);
        const replyDates = poItems.map(row => text(row.REPLYDTTM)).filter(Boolean).sort();
        return {
          rowKey: stockKey(matNo, unit), matNo, unit, matName: text(items[0].MATNM),
          availableQty,
          inTransit: display(sum(poItems, 'INTRANSIT')),
          allocatedQty: sum(materialItems, 'LOCKQTY'),
          shortage: display(coverage.shortage),
          eta: replyDates[replyDates.length - 1] || '',
          status: { shortage: '欠料', normal: '正常' }[coverage.state],
          locations: stockItems.map((raw, stockIndex) => ({
            rowKey: [matNo, unit, raw.IDSEQ, raw.LSTSEQ, stockIndex].join('::'),
            stkName: text(raw.STKNM), lotNo: text(raw.LOTNO), unit,
            qty: stockQuantity(raw.QTY), okQty: stockQuantity(raw.OKQTY)
          })),
          poItems: poItems.map((raw, poIndex) => Object.assign({}, raw, {
            rowKey: text(raw.rowKey) || text(raw.PKID) || [matNo, unit, raw.IDSEQ, raw.LSTSEQ, poIndex].join('::'),
            poNo: text(raw.PONO || raw.IDNO), supplier: text(raw.SUPPNM || raw.SUPNM), unit,
            qty: display(numberOrNull(raw.REQQTY == null || raw.REQQTY === '' ? raw.QTY : raw.REQQTY)),
            inTransit: display(numberOrNull(raw.INTRANSIT)), replyDate: text(raw.REPLYDTTM)
          }))
        };
      });
    }
  }));
  return results.reduce((rows, group) => rows.concat(group), []);
}

// 7. 字段元数据
// 将字段元数据键名统一为大写，便于动态列读取。
function normalizeFieldMetadata(rows) {
  return (rows || []).map(row => Object.keys(row || {}).reduce((result, key) => {
    result[String(key).toUpperCase()] = row[key];
    return result;
  }, {}));
}

// 提取接口返回的列表行数据，校验 code 200 与数组格式。
function extractRows(res, defaultMsg) {
  if (res && String(res.code) === '200' && Array.isArray(res.result)) {
    return res.result;
  }
  const msg = (res && (typeof res.result === 'string' ? res.result : res.message)) || defaultMsg || '读取数据失败';
  throw new Error(msg);
}


const SUMMARY_FIELD_PROPS = Object.freeze({
  IDNO: 'orderNo', CLNTNO: 'clientCode', MATNO: 'sku', MATNM: 'productName', MATDESC: 'model',
  QTY: 'qty', SHPDTTM: 'deliveryDate', STFG: 'orderStatus', LVL: 'priority', PRIORITY: 'priority', READINESS: 'readiness',
  KITQTY: 'kitQty', ROWCNT: 'materialTotalCount', OKDTTM: 'expectedReadyDate', PRDDTTM: 'startDate',
  DELAYDAYS: 'delayDays', NOTMAT: 'shortageCount'
});

export default {
  name: 'OrdSuiteDetail',
  props: { toolbarInTabs: { type: Boolean, default: false } },
  // 声明订单、物料、弹窗及请求生命周期状态。
  data() {
    return {
      initialLoading: true,
      // 当前用户请求上下文。
      v_username: '',
      // 上下工作区布局及物料状态筛选。
      upperHeight: 286,
      summaryFieldRows: [],
      summaryFieldLoading: false,
      summaryFieldError: '',
      summaryFieldsLoaded: false,
      materialStateFilter: 'all',
      // 订单原始数据和订单选择状态。
      orders: EMPTY_ROWS,
      selectedSummary: null,
      // 净物料选择及原始物料来源键。
      selectedMaterials: [],
      selectedMaterialKeys: [],
      netMaterialSelectionSyncing: false,
      // 当前 SKU 的原始请购明细。
      materialNetRows: EMPTY_ROWS,
      // 订单物料查询缓存和请求状态。
      materialQueryRequestId: 0,
      materialQueryLoading: false,
      materialQueryError: '',
      materialSummaryValues: EMPTY_MAP,
      materialSummaryError: '',
      materialSummaryConflictCount: 0,
      // Form 490050/1 返回的字段元数据及加载状态。
      materialFieldRows: [],
      materialFieldLoading: false,
      materialFieldError: '',
      // 订单齐套汇总加载状态和快照信息。
      suiteLoading: false,
      suiteLoaded: false,
      suiteRequestId: 0,
      dataSnapshotAt: '',
      // 下游业务权限。
      permissions: { lock: false },
      // 订单汇总表头筛选条件。
      appliedSummaryFilters: EMPTY_MAP,
      summaryFilters: {
        orderNo: '',
        clientCode: '',
        sku: '',
        productName: '',
        model: '',
        qty: '',
        deliveryDate: '',
        orderStatus: '',
        priority: '',
        readiness: '',
        readinessFilter: 'all',
        expectedReadyDate: '',
        startDate: '',
        delayDays: '',
        shortageState: ''
      },
      // 净物料字段筛选条件。
      netMaterialFilters: {},
      materialSearch: '',
      appliedMaterialSearch: '',
      // 内置 ERP 仓存锁库弹窗
      erpLockDialogVisible: false,
      erpLockChanged: false,
      erpLockContexts: [],
      activeErpLockContext: null,
      erpLockStockRows: [],
      erpLockLockedRows: [],
      erpLockLoading: false,
      erpLockWriting: false,
      // 库位抽屉与真实数据
      locationDrawer: false,
      locationMode: 'single',
      locationTitle: '物料供给与位置明细',
      activeMaterialLocations: [],
      activeMaterialPoItems: [],
      supplyTraceRequestId: 0,
      supplyTraceLoading: false,
      supplyTraceError: '',
      locationOverviewRows: [],
      locationDetailDrawer: false,
      locationDetailTitle: '物料供给明细',
      activeDetailLocations: [],
      activeDetailPoItems: [],
      locationDetailTotals: { available: 0, transit: 0, allocated: 0 }
    };
  },
  computed: {
    summaryColumns() {
      return this.summaryFieldRows.filter(row => text(row.THIDE).toUpperCase() === 'N')
        .slice().sort((a, b) => Number(a.SORTBY || 0) - Number(b.SORTBY || 0))
        .map(row => {
          const key = text(row.KEY || row.FLDNO || row.CODE).toUpperCase();
          return {
            key, prop: SUMMARY_FIELD_PROPS[key] || key,
            title: this.$translate.getColTitle(row, this.$store.state.lang) || key,
            width: Number(row.WIDTH || row.COLWIDTH) > 0 ? Number(row.WIDTH || row.COLWIDTH) : 100,
            align: row.ALIGN || row.CSS || 'left',
            fixed: row.ISFIX === 'Y' ? 'left' : row.ISFIX === 'R' ? 'right' : false
          };
        }).filter(column => column.key && !['SEL', 'ROWNUM', 'OPER'].includes(column.key));
    },
    toolbarSnapshot() {
      return {
        counts: this.readinessSummary, filter: this.summaryFilters.readinessFilter,
        loading: this.suiteLoading || this.initialLoading,
        disabled: this.suiteLoading || this.initialLoading || this.erpLockWriting,
        snapshotAt: this.dataSnapshotAt
      };
    },
    // 应用订单表头字段筛选，但暂不处理顶部齐套状态筛选。
    baseFilteredSummary() {
      const visible = new Set(this.summaryColumns.map(column => column.prop === 'shortageCount' ? 'shortageState' : column.prop));
      const filters = Object.keys(this.appliedSummaryFilters).reduce((result, key) => {
        if (visible.has(key)) result[key] = this.appliedSummaryFilters[key];
        return result;
      }, {});
      const textFilters = ['orderNo', 'clientCode', 'sku', 'productName', 'model']
        .filter(key => filters[key]).map(key => [key, filters[key].toLowerCase()]);
      return this.orders.filter(row => {
        for (let i = 0; i < textFilters.length; i += 1) {
          const [key, query] = textFilters[i];
          if (!String(row[key] || '').toLowerCase().includes(query)) return false;
        }
        if (filters.qty !== undefined && filters.qty !== null && filters.qty !== '' && String(row.qty) !== String(filters.qty)) return false;
        if (filters.deliveryDate && row.deliveryDate !== filters.deliveryDate) return false;
        if (filters.orderStatus && row.orderStatus !== filters.orderStatus) return false;
        if (filters.priority && row.priority !== filters.priority) return false;
        if (filters.readiness && row.readiness !== filters.readiness) return false;
        if (filters.expectedReadyDate && row.expectedReadyDate !== filters.expectedReadyDate) return false;
        if (filters.startDate && row.startDate !== filters.startDate) return false;
        if (filters.delayDays !== undefined && filters.delayDays !== null && filters.delayDays !== '' && String(row.delayDays) !== String(filters.delayDays)) return false;
        if (filters.shortageState === 'has' && (!row.shortageCount || row.shortageCount <= 0)) return false;
        if (filters.shortageState === 'none' && row.shortageCount > 0) return false;
        return true;
      });
    },
    // 在字段筛选结果上追加顶部齐套状态筛选。
    filteredSummary() {
      const filter = this.summaryFilters.readinessFilter;
      let rows = this.baseFilteredSummary;
      if (filter === 'ready') rows = rows.filter(r => r.readiness === '已齐套');
      else if (filter === 'partial') rows = rows.filter(r => r.readiness === '部分齐料');
      else if (filter === 'shortage') rows = rows.filter(r => r.readiness === '未齐套');
      return rows;
    },
    // 统计当前字段筛选范围内各齐套状态数量。
    readinessSummary() {
      const all = this.baseFilteredSummary;
      const counts = { total: all.length, ready: 0, partial: 0, shortage: 0 };
      all.forEach(row => {
        if (row.readiness === '已齐套') counts.ready += 1;
        else if (row.readiness === '部分齐料') counts.partial += 1;
        else if (row.readiness === '未齐套') counts.shortage += 1;
      });
      return counts;
    },
    // 当前只查看一条订单 SKU 明细。
    selectedSkuLabel() {
      const row = this.selectedSummary;
      return row ? row.orderNo + '/' + row.sku : '';
    },
    searchedMaterials() {
      const query = text(this.appliedMaterialSearch).toLowerCase();
      if (!query) return this.materialNetRows;
      const quantity = numberOrNull(query);
      return this.materialNetRows.filter(row => {
        const rowQuantity = numberOrNull(row.QTY == null || row.QTY === '' ? row.REQQTY : row.QTY);
        return text(row.MATNO).toLowerCase().includes(query)
          || text(row.MATNM).toLowerCase().includes(query)
          || text(row.MATDESC).toLowerCase().includes(query)
          || (quantity != null && rowQuantity != null && rowQuantity === quantity);
      });
    },
    // 数量统计与状态筛选共享当前搜索、表头筛选范围。
    baseFilteredNetMaterials() {
      const filters = this.netMaterialFilters || {};
      const activeEntries = Object.entries(filters).filter(([key, val]) =>
        !HIDDEN_MATERIAL_FIELDS.includes(key.toUpperCase()) && val !== undefined && val !== null && String(val).trim() !== '');
      const rows = this.searchedMaterials;
      if (!activeEntries.length) return rows;
      return rows.filter(row => activeEntries.every(([key, val]) => {
        const v = String(val).trim().toLowerCase();
        const cellVal = text(this.materialDisplayValue(row, key)).toLowerCase();
        return cellVal.includes(v);
      }));
    },
    filteredNetMaterials() {
      const state = this.materialStateFilter;
      return state === 'all' ? this.baseFilteredNetMaterials
        : this.baseFilteredNetMaterials.filter(row => this.materialState(row) === state);
    },
    // 物料状态仅按库存能否满足净需求区分欠料和正常。
    materialStateCounts() {
      return this.baseFilteredNetMaterials.reduce((counts, row) => {
        counts.all++;
        const state = this.materialState(row);
        if (counts[state] !== undefined) counts[state]++;
        return counts;
      }, { all: 0, shortage: 0, normal: 0 });
    },
    // 请购单号和请购状态仅在本页隐藏，其余列属性使用接口配置。
    netMaterialColumns() {
      return this.materialFieldRows.filter(row => text(row.THIDE).toUpperCase() === 'N' &&
        !HIDDEN_MATERIAL_FIELDS.includes(text(row.KEY || row.FLDNO || row.CODE).toUpperCase())).map(row => {
        const key = text(row.KEY || row.FLDNO || row.CODE);
        return {
          key,
          prop: key,
          title: this.$translate && this.$translate.getColTitle ? this.$translate.getColTitle(row, this.$store.state.lang) : (row.TITLE || row.COLNAME || key),
          width: Number(row.WIDTH) || 100,
          align: row.ALIGN || 'left',
          fixed: row.ISFIX === 'Y' ? 'left' : (row.ISFIX === 'R' ? 'right' : false)
        };
      });
    },
    selectionColumns() {
      return this.netMaterialColumns.filter(column => column.key === 'SEL');
    },
    displayMaterialColumns() {
      return this.netMaterialColumns.filter(column => column.key !== 'SEL');
    },
    // 汇总供给追踪抽屉中的可用、在途和占用数量。
    locationTotals() {
      const rows = this.locationOverviewRows;
      const sum = key => {
        const isStock = key === 'availableQty' || key === 'allocatedQty';
        if (!rows.length) return isStock ? 0 : null;
        if (new Set(rows.map(row => row.unit)).size > 1) return null;
        let total = 0;
        for (const row of rows) {
          const value = isStock ? stockQuantity(row[key]) : materialQuantity(row[key]);
          if (value == null) return null;
          total += value;
        }
        return total;
      };
      return {
        available: sum('availableQty'),
        transit: sum('inTransit'),
        allocated: sum('allocatedQty')
      };
    }
  },
  // 初始化账套和当前用户身份。
  watch: {
    toolbarSnapshot: {
      immediate: true,
      handler(state) { if (this.toolbarInTabs) this.$emit('toolbar-change', state); }
    }
  },
  created() {
    this._disposed = false;
    this._viewActive = true;
    this._summaryFilterTimer = null;
    this._materialSearchTimer = null;
    this._resizeCleanup = null;
    this._suitePromise = null;
    this._lockRequestId = 0;
    this.appliedSummaryFilters = Object.freeze(Object.assign({}, this.summaryFilters));
    this.v_username = this.$cookies && this.$cookies.get ? this.$cookies.get('v_telno') : '';
  },
  // 加载字段、权限和订单数据，并注册窗口尺寸监听。
  mounted() {
    Promise.all([
      this.loadSummaryFields(),
      this.loadMaterialFieldMetadata().catch(() => {}),
      this.loadPermissions().catch(() => {}),
      this.loadSuiteData().catch(() => {})
    ]).finally(() => {
      if (!this._disposed) {
        this.initialLoading = false;
        this.handleTableLayout();
      }
    });
    window.addEventListener('resize', this.handleWindowResize);
  },
  activated() {
    this._viewActive = true;
    window.addEventListener('resize', this.handleWindowResize);
    this.handleTableLayout();
  },
  deactivated() {
    this._viewActive = false;
    this.commitMaterialSearch();
    if (this._resizeCleanup) this._resizeCleanup();
    window.removeEventListener('resize', this.handleWindowResize);
    // 保留离开前的输入条件，但不在隐藏表格上执行布局。
    if (this._summaryFilterTimer !== null) this.commitSummaryFilters();
    this.closeSupplyTrace();
  },
  // 销毁页面前移除窗口监听，避免重复绑定。
  beforeDestroy() {
    this._disposed = true;
    clearTimeout(this._materialSearchTimer);
    this._materialSearchTimer = null;
    clearTimeout(this._summaryFilterTimer);
    this._summaryFilterTimer = null;
    if (this._resizeCleanup) this._resizeCleanup();
    window.removeEventListener('resize', this.handleWindowResize);
    this.suiteRequestId += 1;
    this.materialQueryRequestId += 1;
    this.supplyTraceRequestId += 1;
    this._lockRequestId += 1;
    this._suitePromise = null;
  },
  methods: {
    summaryColumnValue(row, column) {
      const value = row[column.prop];
      return value == null || value === '' ? '' : String(value);
    },
    async loadSummaryFields() {
      if (this._disposed || this.summaryFieldLoading) return;
      this.summaryFieldLoading = true;
      this.summaryFieldError = '';
      this.summaryFieldsLoaded = false;
      this.summaryFieldRows = [];
      try {
        const res = await getTabColOrData('xuper_auth/getBaseData', 'v_sys_form_fld',
          'idseq', '490050', 'lstseq', '5', '', '', ' order by sortby,lstseq');
        if (this._disposed) return;
        const rows = normalizeFieldMetadata(extractRows(res, '订单字段读取失败'));
        const keys = rows.map(row => text(row.KEY || row.FLDNO || row.CODE).toUpperCase()).filter(Boolean);
        if (new Set(keys).size !== keys.length) throw new Error('订单字段配置存在重复字段');
        this.summaryFieldRows = rows;
        this.summaryFieldsLoaded = true;
        this.$nextTick(() => {
          if (!this._disposed && this.$refs.summaryTable) this.$refs.summaryTable.doLayout();
        });
      } catch (error) {
        if (!this._disposed) this.summaryFieldError = error.message || '订单字段读取失败';
      } finally {
        if (!this._disposed) this.summaryFieldLoading = false;
      }
    },
    // 从 Cookie 读取当前账套企业代码。
    assemblyCorpid() {
      return this.$cookies && this.$cookies.get ? this.$cookies.get('v_corpid') : '';
    },
    // 直连 getTabColOrData 核心查询方法
    // 查询当前账套的订单齐套汇总。
    getOrdList(corpid, cond) {
      const company = text(corpid || this.assemblyCorpid());
      if (!company) return Promise.resolve([]);
      return getTabColOrData(
        'xuper_auth/getBaseData',
        'V_ORD_SUITE',
        'corpid',
        company,
        '',
        '',
        '',
        '',
        cond || ' order by ORDDTTM DESC, IDNO DESC, IDSEQ DESC, LSTSEQ DESC'
      ).then(res => {
        if (res && String(res.code) === '200' && Array.isArray(res.result)) {
          return res.result;
        }
        const msg = (res && (typeof res.result === 'string' ? res.result : res.message)) || '查询订单失败';
        throw new Error(msg);
      });
    },
    // 请购：当前订单产品对应明细。
    getItemData(v_idseq, v_lstseq, v_cond, corpid) {
      const idseq = text(v_idseq);
      const lstseq = text(v_lstseq);
      const company = text(corpid || this.assemblyCorpid());
      if (!idseq || !lstseq || !company) return Promise.reject(new Error('缺少账套或订单行身份'));
      return this.$axios({
        method: 'post',
        url: 'xuper_auth/getBaseData',
        data: {
          p_key: 'ord_idseq', p_value: idseq,
          p_key2: 'ord_lstseq', p_value2: lstseq,
          p_key3: 'corpid', p_value3: company,
          p_table: 'V_po_reqitm',
          p_cond: (v_cond || '') + ' order by matno'
        }
      }).then(res => extractRows(res, '查询订单产品请购明细失败'));
    },
    // 同账套、同订单一次性读取汇总，补充展示和库存状态，不覆盖产品需求或锁库身份。
    getRequestSummaryData(orderIdseq, corpid) {
      if (!text(orderIdseq) || !text(corpid)) return Promise.reject(new Error('缺少账套或订单身份'));
      return getTabColOrData('xuper_auth/getBaseData', 'V_po_reqdtl',
        'ordseq', text(orderIdseq), 'corpid', text(corpid), '', '', ' order by idno, matno')
        .then(res => extractRows(res, '请购汇总补充数据加载失败'));
    },
    // 下表业务列只读取 Form 490050/1，不叠加旧字段配置。
    getMaterialFieldMetadata() {
      return getTabColOrData(
        'xuper_auth/getBaseData',
        'v_sys_form_fld',
        'idseq',
        '490050',
        'lstseq',
        '1',
        '',
        '',
        ' order by sortby,lstseq'
      ).then(res => normalizeFieldMetadata(extractRows(res, '查询物料字段失败')));
    },
    // 只显示返回字段；失败保持空列，允许重试。
    loadMaterialFieldMetadata() {
      if (this._disposed || this.materialFieldLoading) return Promise.resolve();
      this.materialFieldLoading = true;
      this.materialFieldError = '';
      this.materialFieldRows = [];
      this.netMaterialFilters = {};
      return this.getMaterialFieldMetadata().then(rows => {
        if (this._disposed) return;
        this.materialFieldRows = rows;
        this.netMaterialColumns.forEach(column => {
          if (column.key !== 'SEL') this.$set(this.netMaterialFilters, column.prop, '');
        });
        this.handleMaterialFilterChange();
      }).catch(error => {
        if (!this._disposed) this.materialFieldError = error.message || '物料状态明细字段读取失败';
      }).finally(() => {
        if (!this._disposed) this.materialFieldLoading = false;
      });
    },
    // 查询锁库业务表单的用户权限。
    loadPermissions() {
      if (this._disposed) return Promise.resolve();
      const forms = [{ key: 'lock', id: '16572' }];
      return Promise.all(forms.map(form => getTabColOrData(
        'xuper_auth/getBaseData',
        'v_sys_user_priv',
        'userno',
        this.v_username,
        'frmidseq',
        form.id,
        '',
        '',
        " and issel='Y'"
      ).then(res => ({ key: form.key, allowed: String(res && res.code) === '200' && Array.isArray(res.result) && res.result.length > 0 })).catch(() => ({ key: form.key, allowed: false })))).then(results => {
        if (!this._disposed) results.forEach(item => { this.permissions[item.key] = item.allowed; });
      });
    },
    // 加载订单齐套汇总并丢弃过期请求结果。
    loadSuiteData(force) {
      if (this._disposed) return Promise.resolve();
      if (this.suiteLoading) return this._suitePromise;
      if (this.suiteLoaded && !force) return Promise.resolve();
      const corpid = this.assemblyCorpid();
      if (!corpid) {
        this.clearMaterialContext(); this.resetNetMaterialFilters(); this.orders = EMPTY_ROWS; this.selectedSummary = null;
        return Promise.resolve([]);
      }
      const previous = this.selectedSummary && this.summaryRowKey(this.selectedSummary);
      this.clearMaterialContext();
      const requestId = this.suiteRequestId + 1;
      this.suiteRequestId = requestId;
      this.suiteLoading = true;
      const promise = this.getOrdList(corpid).then(async rawOrders => {
        if (this._disposed || requestId !== this.suiteRequestId) return;
        this.orders = freezeSnapshot(filterSuiteRows(rawOrders, corpid));
        const visibleRows = this.filteredSummary;
        const nextRow = visibleRows.find(row => this.summaryRowKey(row) === previous) || visibleRows[0] || null;
        this.suiteLoaded = true;
        this.dataSnapshotAt = new Date().toLocaleString(this.$store.state.lang === 'EN' ? 'en-US' : 'zh-CN', { hour12: false });
        if (nextRow) await this.applySummaryRow(nextRow);
        else {
          this.selectedSummary = null; this.resetNetMaterialFilters();
          if (this.$refs.summaryTable) this.$refs.summaryTable.setCurrentRow();
        }
      }).catch(error => {
        if (this._disposed || requestId !== this.suiteRequestId) return;
        this.orders = EMPTY_ROWS; this.selectedSummary = null; this.resetNetMaterialFilters();
        const errMsg = error && error.message ? error.message : '齐套数据读取失败';
        this.$message.error(errMsg);
      }).finally(() => {
        if (!this._disposed && requestId === this.suiteRequestId) {
          this.suiteLoading = false;
          this._suitePromise = null;
        }
      });
      this._suitePromise = promise;
      return promise;
    },
    // 按当前选中订单刷新净物料及订单来源映射。
    async refreshSelectedMaterials() {
      if (this._disposed) return;
      const row = this.selectedSummary;
      const selectedKeys = this.selectedMaterialKeys.slice();
      const requestId = this.materialQueryRequestId + 1;
      this.materialQueryRequestId = requestId;
      this.materialQueryError = '';
      this.materialSummaryValues = EMPTY_MAP;
      this.materialSummaryError = '';
      this.materialSummaryConflictCount = 0;
      this.materialNetRows = EMPTY_ROWS;
      this.selectedMaterials = []; this.selectedMaterialKeys = [];
      if (!row) {
        this.materialQueryLoading = false;
        return;
      }
      this.materialQueryLoading = true;
      const corpid = this.assemblyCorpid();
      try {
        const [result, summary] = await Promise.all([
          loadSkuMaterials(this, row, corpid),
          this.getRequestSummaryData(row.IDSEQ || row.idseq, corpid)
            .then(rows => ({ rows, failed: false })).catch(() => ({ rows: [], failed: true }))
        ]);
        if (this._disposed || requestId !== this.materialQueryRequestId || this.selectedSummary !== row ||
            text(this.assemblyCorpid()) !== text(corpid)) return;
        const display = buildRequestSummaryDisplay(result, summary.rows, corpid, row.IDSEQ || row.idseq);
        this.materialSummaryValues = freezeSnapshot(display.values);
        this.materialSummaryConflictCount = display.conflictCount;
        this.materialSummaryError = summary.failed ? '请购汇总补充数据加载失败' : '';
        this.materialNetRows = freezeSnapshot(result);
        const availableKeys = new Set(this.materialNetRows.map(item => item.rowKey));
        this.selectedMaterialKeys = selectedKeys.filter(key => availableKeys.has(key));
        this.syncSelectedMaterialsFromKeys(this.selectedMaterialKeys);
      } catch (error) {
        if (this._disposed || requestId !== this.materialQueryRequestId || text(this.assemblyCorpid()) !== text(corpid)) return;
        this.materialQueryError = error && error.message ? error.message : '物料查询失败，可重试';
      } finally {
        if (!this._disposed && requestId === this.materialQueryRequestId) this.materialQueryLoading = false;
      }
    },
    // 返回订单优先级对应的样式类。
    priorityClass(priority) {
      if (priority === '紧急') return 'is-urgent';
      if (priority === '高') return 'is-high';
      return 'is-normal';
    },
    // 返回齐套状态对应的样式类。
    readinessClass(status) {
      if (status === '已齐套') return 'ready';
      if (status === '部分齐料') return 'partial';
      return 'missing';
    },
    // 列表状态、计数、筛选使用与表格相同的库存数据。
    materialCoverage(row) {
      return materialCoverage(key => this.materialDisplayValue(row, key));
    },
    materialState(row) {
      return this.materialCoverage(row).state;
    },
    // 分组固定列的父表头同步宽度，避免拖宽后被固定区域裁切。
    handleSummaryColumnResize(width, oldWidth, column) {
      const key = column.columnKey;
      const field = this.summaryFieldRows.find(row => text(row.KEY || row.FLDNO || row.CODE).toUpperCase() === key);
      if (field) this.$set(field, 'WIDTH', width);
      this.$nextTick(() => {
        if (this._disposed || !this.$refs.summaryTable) return;
        this.$refs.summaryTable.doLayout();
        if (this.selectedSummary) this.$refs.summaryTable.setCurrentRow(this.selectedSummary);
      });
    },
    // 拖动列宽只更新当前页面的字段定义，不写入后台配置。
    handleMaterialColumnResize(width, oldWidth, column) {
      const key = column.property || column.columnKey;
      const field = this.materialFieldRows.find(row => text(row.KEY || row.FLDNO || row.CODE) === key);
      if (field) this.$set(field, 'WIDTH', width);
    },
    // 单元格、筛选与库存状态共享展示值，写入操作仍使用原始行身份。
    materialDisplayValue(row, key) {
      const value = readMaterialFieldValue(row, key);
      const additions = row && this.materialSummaryValues[row.rowKey];
      const field = String(key).toUpperCase();
      const resolved = hasMaterialValue(value) ? value : additions && additions[field];
      return STOCK_QUANTITY_FIELDS.includes(field) ? stockQuantity(resolved) : resolved;
    },
    materialColumnValue(row, key) {
      const value = this.materialDisplayValue(row, key);
      return hasMaterialValue(value) ? String(value) : '';
    },
    // 按展示的采购状态着色，与订单页一致；原始记录未返回时读取汇总补充值。
    materialRowClassName({ row }) {
      return POST_STATUS[text(this.materialDisplayValue(row, 'POSTFG'))] || 'status-unknown';
    },
    // 返回订单表稳定的复合行键。
    summaryRowKey(row) {
      if (!row) return '';
      return row.orderKey || row.rowKey || '';
    },
    // 固定订单汇总表数据行高度。
    summaryRowStyle() {
      return { height: '32px', cursor: 'pointer' };
    },
    // 控制净物料行是否允许选择。
    materialSelectable(row) {
      return !!row && isRealMaterial(row.MATNO);
    },
    // 更新顶部齐套状态筛选。
    setReadinessFilter(status) {
      this.summaryFilters.readinessFilter = status;
      this.syncSelectedSummaryWithFiltered();
    },
    // 订单筛选变化后重新计算表格布局。
    handleSummaryFilterChange() {
      clearTimeout(this._summaryFilterTimer);
      if (this._disposed) return;
      this._summaryFilterTimer = setTimeout(() => this.commitSummaryFilters(), 200);
    },
    commitSummaryFilters() {
      clearTimeout(this._summaryFilterTimer);
      this._summaryFilterTimer = null;
      if (this._disposed) return;
      this.appliedSummaryFilters = Object.freeze(Object.assign({}, this.summaryFilters));
      this.syncSelectedSummaryWithFiltered();
      this.$nextTick(() => {
        if (this._disposed || !this._viewActive) return;
        if (this.$refs.summaryTable) this.$refs.summaryTable.doLayout();
      });
    },
    // 保持当前选中的订单与筛选后的视图可见行严格对齐
    syncSelectedSummaryWithFiltered() {
      const visibleRows = this.filteredSummary;
      if (!this.selectedSummary) {
        if (visibleRows.length > 0) this.applySummaryRow(visibleRows[0]);
        return;
      }
      const isVisible = visibleRows.some(row => this.summaryRowKey(row) === this.summaryRowKey(this.selectedSummary));
      if (!isVisible) {
        if (visibleRows.length > 0) {
          this.applySummaryRow(visibleRows[0]);
        } else {
          this.selectedSummary = null;
          this.clearMaterialContext();
          this.resetNetMaterialFilters();
          if (this.$refs.summaryTable) this.$refs.summaryTable.setCurrentRow(null);
        }
      } else {
        this.$nextTick(() => {
          if (!this._disposed && this.$refs.summaryTable && this.selectedSummary) {
            this.$refs.summaryTable.setCurrentRow(this.selectedSummary);
          }
        });
      }
    },
    // 物料筛选变化后重新计算净物料表布局。
    handleMaterialFilterChange() {
      this.$nextTick(() => {
        if (this._disposed || !this._viewActive) return;
        if (this.$refs.netMaterialTable) this.$refs.netMaterialTable.doLayout();
      });
    },
    // 清空订单表全部筛选条件。
    resetSummaryFilters() {
      this.summaryFilters = {
        orderNo: '',
        clientCode: '',
        sku: '',
        productName: '',
        model: '',
        qty: '',
        deliveryDate: '',
        orderStatus: '',
        priority: '',
        readiness: '',
        readinessFilter: 'all',
        expectedReadyDate: '',
        startDate: '',
        delayDays: '',
        shortageState: ''
      };
      this.commitSummaryFilters();
    },
    // 使用单个订单行替换当前分析范围并同步表格选择。
    selectSummaryRow(row) {
      if (!row || this._disposed || this.suiteLoading || this.erpLockWriting) return Promise.resolve(false);
      if (this.selectedSummary && this.summaryRowKey(this.selectedSummary) === this.summaryRowKey(row)) {
        return Promise.resolve(true);
      }
      return this.applySummaryRow(row);
    },
    applySummaryRow(row) {
      const changed = !this.selectedSummary || this.summaryRowKey(this.selectedSummary) !== this.summaryRowKey(row);
      if (changed) this.resetNetMaterialFilters();
      this.clearMaterialContext();
      this.selectedSummary = row;
      const request = this.refreshSelectedMaterials();
      this.$nextTick(() => {
        if (!this._disposed && this.$refs.summaryTable) {
          this.$refs.summaryTable.setCurrentRow(row);
        }
      });
      return request;
    },
    clearMaterialContext() {
      this.materialQueryRequestId++;
      this.materialQueryLoading = false; this.materialQueryError = '';
      this.materialSummaryValues = EMPTY_MAP; this.materialSummaryError = ''; this.materialSummaryConflictCount = 0;
      this.materialNetRows = EMPTY_ROWS; this.selectedMaterials = []; this.selectedMaterialKeys = [];
      this.closeSupplyTrace();
      if (this.$refs.netMaterialTable) {
        this.$refs.netMaterialTable.clearSelection();
      }
      if (!this.erpLockWriting) {
        this._lockRequestId++;
        this.erpLockLoading = false; this.erpLockDialogVisible = false;
        this.erpLockStockRows = []; this.erpLockLockedRows = [];
        this.erpLockContexts = []; this.activeErpLockContext = null;
      }
    },
    closeSupplyTrace() {
      this.supplyTraceRequestId++;
      this.supplyTraceLoading = false; this.supplyTraceError = '';
      this.locationDrawer = false; this.locationDetailDrawer = false;
      this.locationOverviewRows = []; this.activeMaterialLocations = []; this.activeMaterialPoItems = [];
      this.activeDetailLocations = []; this.activeDetailPoItems = [];
    },
    // 更新物料状态筛选条件。
    setMaterialStateFilter(filter) {
      this.materialStateFilter = filter;
    },
    // 监听净物料选择变更（配合 reserve-selection 支持跨筛选自动保留勾选项）。
    handleNetMaterialSelection(rows) {
      if (this.netMaterialSelectionSyncing) return;
      const selectedRows = Array.isArray(rows) ? rows : [];
      this.selectedMaterials = selectedRows;
      this.selectedMaterialKeys = selectedRows.map(row => this.materialRowKey(row));
    },
    // 手动清空已勾选的所有物料。
    clearNetMaterialSelection() {
      this.selectedMaterials = [];
      this.selectedMaterialKeys = [];
      if (this.$refs.netMaterialTable) {
        this.$refs.netMaterialTable.clearSelection();
      }
    },
    // 返回净物料及锁库明细的稳定行键。
    materialRowKey(row) {
      if (!row) return '';
      return row.rowKey || row.ROWKEY || row.pkid || [row.matNo || row.MATNO, row.idseq, row.lstseq].filter(Boolean).join('-');
    },
    lockContextRowKey(row) {
      if (!row) return '';
      return row.lockContextKey || [row.corpid, row.reqSeq, row.reqItm, row.matNo || row.MATNO, row.unit || row.UNITNM].join('::');
    },
    locationOverviewRowKey(row) {
      if (!row) return '';
      return stockKey(row.matNo || row.MATNO, row.unit || row.UNITNM);
    },
    // 仅清空净物料表筛选条件。
    resetNetMaterialFilters() {
      this.materialStateFilter = 'all';
      this.materialSearch = '';
      this.commitMaterialSearch();
      const nextFilters = {};
      this.netMaterialColumns.forEach(column => { if (column.key !== 'SEL') nextFilters[column.prop] = ''; });
      this.netMaterialFilters = nextFilters;
      this.handleMaterialFilterChange();
    },
    handleMaterialSearch() {
      clearTimeout(this._materialSearchTimer);
      if (this._disposed) return;
      this._materialSearchTimer = setTimeout(() => this.commitMaterialSearch(), 200);
    },
    commitMaterialSearch() {
      clearTimeout(this._materialSearchTimer);
      this._materialSearchTimer = null;
      if (this._disposed) return;
      this.appliedMaterialSearch = this.materialSearch;
      this.handleMaterialFilterChange();
    },
    // 按明细行键恢复选择。
    syncSelectedMaterialsFromKeys(keys) {
      this.selectedMaterialKeys = Array.from(new Set(keys || []));
      const keySet = new Set(this.selectedMaterialKeys);
      this.selectedMaterials = this.materialNetRows.filter(row => keySet.has(this.materialRowKey(row)));
      this.syncMaterialTableSelection();
    },
    // 将统一选择状态回填到净物料 Element 表格。
    syncMaterialTableSelection() {
      const table = this.$refs.netMaterialTable;
      if (!table) return;
      const keySet = new Set(this.selectedMaterialKeys || []);
      this.netMaterialSelectionSyncing = true;
      table.clearSelection();
      this.filteredNetMaterials.forEach(row => {
        const rowKey = row.rowKey || row.ROWKEY;
        if (keySet.has(rowKey)) {
          table.toggleRowSelection(row, true);
        }
      });
      this.$nextTick(() => { if (!this._disposed) this.netMaterialSelectionSyncing = false; });
    },
    // 触发表格布局更新。
    handleTableLayout() {
      this.$nextTick(() => {
        if (this._disposed || !this._viewActive) return;
        ['summaryTable', 'netMaterialTable'].forEach(ref => {
          if (this.$refs[ref]) this.$refs[ref].doLayout();
        });
      });
    },
    // 启动上下表格分割条拖拽调整。
    startResize(e) {
      if (this._disposed || !this._viewActive) return;
      if (this._resizeCleanup) this._resizeCleanup();
      e.preventDefault();
      const startY = e.clientY;
      const startHeight = this.upperHeight;
      const moveHandler = ev => {
        const newHeight = Math.max(160, Math.min(600, startHeight + ev.clientY - startY));
        this.upperHeight = newHeight;
      };
      const upHandler = () => {
        document.removeEventListener('mousemove', moveHandler);
        document.removeEventListener('mouseup', upHandler);
        this._resizeCleanup = null;
        this.handleTableLayout();
      };
      this._resizeCleanup = upHandler;
      document.addEventListener('mousemove', moveHandler);
      document.addEventListener('mouseup', upHandler);
    },
    // 窗口变化时重新计算表格布局。
    handleWindowResize() {
      this.handleTableLayout();
    },

    // 锁库逻辑（内置）
    // 当前行就是独立请购明细，直接构建可编辑锁库上下文。
    async openSingleMaterialLock(item) {
      if (!item || this._disposed || this.erpLockWriting || !this.permissions.lock || !isRealMaterial(item.MATNO)) return;
      const corpid = this.assemblyCorpid();
      const reqSeq = text(item.IDSEQ);
      const reqItm = text(item.LSTSEQ);
      const matNo = text(item.MATNO);
      const unit = text(item.UNITNM || item.BOMUNITNM);
      if (!corpid || !reqSeq || !reqItm || !matNo) {
        this.$message.warning('缺少请购明细身份或物料编码，不能锁库');
        return;
      }
      const demandQty = numberOrNull(item.REQQTY == null || item.REQQTY === '' ? item.QTY : item.REQQTY);
      const lockedQty = stockQuantity(item.LOCKQTY);
      const context = Object.assign({}, item, {
        lockContextKey: [corpid, reqSeq, reqItm, matNo, unit].join('::'),
        corpid,
        reqSeq,
        reqItm,
        identityValid: true,
        matNo,
        unit,
        matName: text(item.MATNM),
        demandQty,
        availableQty: this.materialDisplayValue(item, 'STKOKQTY'),
        lockedQty,
        remainingQty: demandQty == null ? null : Math.max(0, demandQty - lockedQty)
      });
      this.erpLockContexts = [context];
      this.activeErpLockContext = context;
      this.erpLockChanged = false;
      this.erpLockDialogVisible = true;
      await this.refreshErpLockData();
    },
    // 切换当前锁库物料并刷新库存与锁定明细。
    async handleErpLockContextClick(row) {
      if (this.erpLockWriting) return;
      this.activeErpLockContext = row;
      await this.refreshErpLockData();
    },
    // 回读当前物料的分仓库存和已锁库记录。
    async refreshErpLockData() {
      if (this._disposed || !this.activeErpLockContext) return;
      const context = this.activeErpLockContext;
      const requestId = ++this._lockRequestId;
      this.erpLockLoading = true;
      this.erpLockStockRows = []; this.erpLockLockedRows = [];
      try {
        const corpid = this.activeErpLockContext.corpid;
        const matNo = this.activeErpLockContext.matNo;
        const reqSeq = this.activeErpLockContext.reqSeq;
        const reqItm = this.activeErpLockContext.reqItm;
        const [stocksRes, lockedsRes] = await Promise.all([
          getTabColOrData('xuper_auth/getTableRecMany', 'V_IC_STKLOG', 'corpid', corpid, 'matno', matNo, '', '', ' order by STKNM desc'),
          getTabColOrData('xuper_auth/getBaseData', 'V_IC_STKLOG_DTL', 'corpid', corpid, 'reqseq', reqSeq, 'reqitm', reqItm, ' order by idseq desc')
        ]);
        if (this._disposed || requestId !== this._lockRequestId || this.activeErpLockContext !== context || !this.erpLockDialogVisible) return;
        this.erpLockStockRows = (extractRows(stocksRes, '读取库存失败') || []).map(r => ({
          ...r, QTY: stockQuantity(r.QTY), OKQTY: stockQuantity(r.OKQTY), ALLOQTY: null
        }));
        this.erpLockLockedRows = (extractRows(lockedsRes, '读取锁库记录失败') || []).map(r => ({
          ...r, QTY: stockQuantity(r.QTY)
        }));
        const lockedQty = this.erpLockLockedRows.reduce((sum, row) => sum + (Number(row.QTY) || 0), 0);
        this.erpLockContexts = this.erpLockContexts.map(context => context === this.activeErpLockContext
          || (context.matNo === matNo && context.reqSeq === reqSeq && context.reqItm === reqItm && context.corpid === corpid)
          ? Object.assign({}, context, {
            lockedQty,
            remainingQty: Math.max(0, (Number(context.demandQty) || 0) - lockedQty)
          })
          : context);
        this.activeErpLockContext = this.erpLockContexts.find(context => context.matNo === matNo && context.reqSeq === reqSeq && context.reqItm === reqItm) || this.activeErpLockContext;
      } catch (err) {
        if (this._disposed || requestId !== this._lockRequestId) return;
        console.error('[锁库数据读取失败]', err);
        this.$message.error((err && err.message) || '读取ERP锁库数据失败');
      } finally {
        if (!this._disposed && requestId === this._lockRequestId) this.erpLockLoading = false;
      }
    },
    // 校验分配量后写入 IC_STKLOG_DTL 锁库明细。
    async allocateErpLock(stockRow) {
      if (this._disposed || this.erpLockWriting || this.erpLockLoading) return;
      const context = this.activeErpLockContext;
      const qty = Number(stockRow && stockRow.ALLOQTY);
      const available = Math.max(0, stockQuantity(stockRow && stockRow.OKQTY));
      if (!context || !context.identityValid || !stockRow || !Number.isFinite(qty) || qty <= 0) return;
      if (qty > available || qty > Math.max(0, Number(context.remainingQty) || 0)) {
        this.$message.warning('分配数量不能超过当前可用量和剩余需求');
        return;
      }
      this.erpLockWriting = true;
      const confirmed = await this.$confirm('确定分配该仓位库存吗？', '提示', { type: 'warning' }).then(() => true).catch(() => false);
      if (!confirmed || this._disposed) { if (!this._disposed) this.erpLockWriting = false; return; }
      try {
        const payload = {
          IDSEQ: stockRow.IDSEQ,
          LSTSEQ: stockRow.LSTSEQ,
          STKNO: stockRow.STKNO,
          LOTNO: stockRow.LOTNO,
          REQSEQ: context.reqSeq,
          REQITM: context.reqItm,
          CORPID: context.corpid,
          MATNO: context.matNo,
          QTY: qty
        };
        const res = await this.$axios({
          method: 'post',
          url: 'xuper_auth/tableBodySave',
          data: { p_json: JSON.stringify(payload), p_table: 'IC_STKLOG_DTL', p_idseq: stockRow.IDSEQ }
        });
        if (!res || String(res.code) !== '200') throw new Error((res && res.result) || '分配失败');
        this.$message.success('锁库分配成功');
        this.erpLockChanged = true;
        await this.refreshErpLockData();
        await this.refreshSelectedMaterials();
      } catch (err) {
        this.$message.error(err.message || '分配失败');
      } finally {
        this.erpLockWriting = false;
      }
    },
    // 二次确认后删除指定锁库明细。
    async releaseErpLock(lockedRow) {
      if (this._disposed || this.erpLockWriting || this.erpLockLoading || !lockedRow || !lockedRow.IDSEQ) return;
      this.erpLockWriting = true;
      const confirmed = await this.$confirm('确定释放该条锁库记录吗？', '提示', { type: 'warning' }).then(() => true).catch(() => false);
      if (!confirmed || this._disposed) { if (!this._disposed) this.erpLockWriting = false; return; }
      try {
        const res = await this.$axios({
          method: 'post',
          url: 'xuper_auth/delTabRec',
          data: { p_key: 'idseq', p_value: lockedRow.IDSEQ, p_key2: 'lstseq', p_value2: lockedRow.LSTSEQ, p_table: 'IC_STKLOG_DTL' }
        });
        if (!res || String(res.code) !== '200') throw new Error((res && res.result) || '释放失败');
        this.$message.success('已成功释放锁库');
        this.erpLockChanged = true;
        await this.refreshErpLockData();
        await this.refreshSelectedMaterials();
      } catch (err) {
        this.$message.error(err.message || '释放失败');
      } finally {
        this.erpLockWriting = false;
      }
    },
    // 弹窗关闭后，若发生过实际分配或释放，按需同步订单汇总齐套数据。
    async handleErpLockDialogClose() {
      if (this.erpLockChanged) {
        this.erpLockChanged = false;
        await this.loadSuiteData(true);
      }
    },
    // 判断当前物料分录是否支持锁库操作。
    canLockRow(row) {
      return !!row && isRealMaterial(row.MATNO);
    },

    // 供给追踪
    // 打开单物料供给追踪，复用该请购行并查询库存。
    async openSupplyTrace(row) {
      if (!row || this._disposed) return;
      const matNo = text(row.MATNO);
      if (!isRealMaterial(matNo)) {
        this.$message.warning('仅真实物料支持供给追踪');
        return;
      }
      const corpid = this.assemblyCorpid();
      if (!corpid) {
        this.$message.warning('缺少账套，不能查询供给信息');
        return;
      }
      const requestId = this.supplyTraceRequestId + 1;
      this.supplyTraceRequestId = requestId;
      const selectedSummary = this.selectedSummary;
      const matName = text(row.MATNM) || matNo;
      this.locationMode = 'single';
      this.locationTitle = matNo + ' · ' + matName + ' · 供给追踪';
      this.locationOverviewRows = [];
      this.activeMaterialLocations = [];
      this.activeMaterialPoItems = [];
      this.locationDetailDrawer = false;
      this.locationDrawer = true;
      this.supplyTraceLoading = true;
      this.supplyTraceError = '';
      try {
        const rows = await loadMaterialSupply(this, [row], corpid);
        if (this._disposed || requestId !== this.supplyTraceRequestId || !this.locationDrawer || this.selectedSummary !== selectedSummary) return;
        this.locationOverviewRows = freezeSnapshot(rows);
        this.activeMaterialLocations = rows.reduce((all, item) => all.concat(item.locations), []);
        this.activeMaterialPoItems = rows.reduce((all, item) => all.concat(item.poItems), []);
      } catch (error) {
        if (!this._disposed && requestId === this.supplyTraceRequestId && this.locationDrawer) {
          this.supplyTraceError = error.message || '读取物料供给失败';
          this.$message.error(this.supplyTraceError);
        }
      } finally {
        if (!this._disposed && requestId === this.supplyTraceRequestId) this.supplyTraceLoading = false;
      }
    },
    // 打开当前选择范围的多物料供给总览。
    async openSelectedLocation() {
      if (this._disposed) return;
      const targets = (this.selectedMaterials || []).filter(row => isRealMaterial(row.MATNO));
      if (!targets.length) {
        this.$message.warning('请先在物料列表中勾选需要追踪的物料');
        return;
      }
      const corpid = this.assemblyCorpid();
      if (!corpid) { this.$message.warning('缺少账套，不能查询供给信息'); return; }
      const requestId = ++this.supplyTraceRequestId;
      const selectedSummary = this.selectedSummary;
      this.locationMode = 'multiple';
      this.locationTitle = '所选物料供给追踪总览 (' + targets.length + '项)';
      this.locationOverviewRows = [];
      this.activeMaterialLocations = []; this.activeMaterialPoItems = [];
      this.locationDetailDrawer = false;
      this.locationDrawer = true;
      this.supplyTraceLoading = true;
      this.supplyTraceError = '';
      try {
        const rows = await loadMaterialSupply(this, targets, corpid);
        if (this._disposed || requestId !== this.supplyTraceRequestId || !this.locationDrawer || this.selectedSummary !== selectedSummary) return;
        this.locationOverviewRows = freezeSnapshot(rows);
      } catch (error) {
        if (!this._disposed && requestId === this.supplyTraceRequestId && this.locationDrawer) {
          this.supplyTraceError = error.message || '读取物料供给失败';
          this.$message.error(this.supplyTraceError);
        }
      } finally {
        if (!this._disposed && requestId === this.supplyTraceRequestId) this.supplyTraceLoading = false;
      }
    },
    // 打开供给总览中的单物料二级详情。
    openLocationDetail(row) {
      this.locationDetailTitle = row.matNo + ' · ' + row.matName + ' 供给详情';
      this.activeDetailLocations = Array.isArray(row.locations) ? row.locations : [];
      this.activeDetailPoItems = Array.isArray(row.poItems) ? row.poItems : [];
      this.locationDetailTotals = { available: row.availableQty, transit: row.inTransit, allocated: row.allocatedQty };
      this.locationDetailDrawer = true;
    }
  }
};
</script>

<style scoped>
.kit-material-workbench {
  --background: #f6f7f9;
  --foreground: #0b1019;
  --card: #ffffff;
  --card-foreground: #0b1019;
  --popover: #ffffff;
  --popover-foreground: #0b1019;
  --primary: #2563eb;
  --primary-foreground: #ffffff;
  --secondary: #f4f4f5;
  --secondary-foreground: #0b1019;
  --muted: #f4f4f5;
  --muted-foreground: #a6abb4;
  --accent: #eff6ff;
  --accent-foreground: #1d4ed8;
  --destructive: #dc2626;
  --destructive-foreground: #ffffff;
  --border: #e4e4e7;
  --input: #d4d4d8;
  --ring: #2563eb;
  --success: #15803d;
  --success-soft: #ecfdf3;
  --warning: #b45309;
  --warning-soft: #fff7ed;
  --shortage-row: #fff1f2;
  --shortage-row-hover: #ffe4e6;
  --radius: 6px;
  --shadow-overlay: 0 18px 48px rgba(24, 24, 27, 0.16);
  --bg: var(--background);
  --surface: var(--card);
  --surface-subtle: #fafafa;
  --line: var(--border);
  --line-strong: var(--input);
  --text: var(--foreground);
  --primary-soft: var(--accent);
  --danger: var(--destructive);
  --danger-soft: var(--shortage-row);
  --font-size-body: 12px;
  --font-size-hint: 12px;
  --font-size-table-header: 12px;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-height: 0;
  overflow: hidden;
  background: var(--bg);
  color: var(--text);
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
  font-size: var(--font-size-body);
  box-sizing: border-box;
}

.query-band {
  flex: 0 0 auto;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 0;
  overflow: hidden;
}

.dimension-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  height: 36px;
  min-height: 36px;
  padding: 0 16px;
  background: var(--surface);
}

.readiness-filter-group {
  display: flex;
  gap: 4px;
}
.readiness-chip {
  padding: 3px 10px;
  border-radius: 4px;
  border: 1px solid #cbd5e1;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}
.readiness-chip:hover {
  background: #f1f5f9;
}
.readiness-chip.is-active {
  background: #0f172a;
  color: #fff;
  border-color: #0f172a;
}
.readiness-chip.ready.is-active {
  background: #16a34a;
  border-color: #16a34a;
}
.readiness-chip.partial.is-active {
  background: #ea580c;
  border-color: #ea580c;
}
.readiness-chip.shortage.is-active {
  background: #dc2626;
  border-color: #dc2626;
}

.dimension-nav-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
.data-snapshot-hint {
  font-size: 12px;
  color: var(--muted-foreground);
  margin-right: 6px;
}

.pane {
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: var(--surface);
  border: 1px solid var(--line);
  border-top: 0;
}
.upper-pane { flex: 0 0 auto; }
.lower-pane { flex: 1 1 auto; border-top: 1px solid var(--line); }
.table-wrap { flex: 1; min-height: 0; overflow: hidden; }
.material-query-error {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  min-height: 30px;
  padding: 0 10px;
  color: var(--danger);
  background: #fff5f5;
  border-top: 1px solid #fecaca;
  border-bottom: 1px solid #fecaca;
  font-size: 12px;
}
.material-query-error span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.material-query-warning {
  color: #b45309;
  background: #fffbeb;
  border-color: #fde68a;
}

.splitter {
  position: relative;
  flex: 0 0 9px;
  cursor: row-resize;
  background: var(--muted);
  border-left: 1px solid var(--line);
  border-right: 1px solid var(--line);
}
.splitter::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 50%;
  width: 42px;
  height: 3px;
  border-radius: 3px;
  background: var(--input);
  transform: translateX(-50%);
}
.splitter:hover::after { background: var(--primary); }

.material-section-title {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 600;
}

.material-workbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  padding: 6px 10px;
  border-bottom: 1px solid var(--line);
  background: #fff;
}

.selected-sku-context {
  flex: 1 1 110px;
  min-width: 0;
  color: var(--muted-foreground);
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}
.material-quick-search { width:250px; max-width:100%; flex:0 1 250px; }

.material-state-filter {
  display: flex;
  gap: 4px;
}
.state-filter-button {
  padding: 3px 10px;
  border-radius: 4px;
  border: 1px solid #cbd5e1;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}
.state-filter-button:hover { background: #f1f5f9; }
.state-filter-button.is-active { background: #0f172a; color: #fff; border-color: #0f172a; }
.state-filter-button.shortage.is-active { background: #dc2626; border-color: #dc2626; }
.state-filter-button.normal.is-active { background: #16a34a; border-color: #16a34a; }

.selection-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.shadcn-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius);
  font-weight: 500;
  font-size: 12px;
  height: 28px;
  padding: 0 10px;
  transition: all 0.15s ease;
}
.shadcn-button--outline { background: #fff; color: #0f172a; border: 1px solid #cbd5e1; }
.shadcn-button--outline:hover { background: #f1f5f9; }
.shadcn-button--ghost { background: transparent; color: #0f172a; border: none; }
.shadcn-button--ghost:hover { background: #f1f5f9; }

.danger-text { color: #dc2626; font-weight: 600; }
.warning-text { color: #ea580c; font-weight: 600; }
.success-text { color: #16a34a; font-weight: 600; }

.readiness-cell {
  display: flex;
  align-items: center;
  width: 100%;
}
.readiness-bar {
  position: relative;
  width: 100%;
  height: 16px;
  background: #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}
.readiness-bar-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: #2563eb;
  transition: width 0.3s;
}
.readiness-cell.ready .readiness-bar-fill { background: #16a34a; }
.readiness-cell.partial .readiness-bar-fill { background: #ea580c; }
.readiness-cell.missing .readiness-bar-fill { background: #dc2626; }
.readiness-bar-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  text-shadow: 0 0 2px rgba(0,0,0,0.6);
}

.priority-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 4px;
}
.priority-dot.is-urgent { background: #dc2626; }
.priority-dot.is-high { background: #ea580c; }
.priority-dot.is-normal { background: #16a34a; }

.table-link {
  background: none;
  border: none;
  color: #2563eb;
  cursor: pointer;
  font-size: 12px;
  padding: 0 4px;
}
.table-link:hover { text-decoration: underline; }
.table-link:disabled {
  color: #94a3b8;
  cursor: not-allowed;
  text-decoration: none;
}
.material-operation-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  white-space: nowrap;
}

.drawer-body { padding: 16px; font-size: 12px; }
.location-summary { display: flex; gap: 20px; background: #f8fafc; padding: 12px; border-radius: 6px; margin-bottom: 16px; }
.location-summary div { display: flex; flex-direction: column; }
.location-summary strong { font-size: 18px; color: #0f172a; }
.location-summary span { font-size: 11px; color: #64748b; }
.drawer-section { margin-bottom: 20px; }
.drawer-heading { font-size: 13px; font-weight: 700; color: #0f172a; margin-bottom: 8px; }

/* 深度定制 Element-UI 内部样式（1:1 完全对齐 mat_suite_openai） */
.kit-material-workbench ::v-deep .el-table tbody tr {
  height: 32px;
}

.kit-material-workbench ::v-deep .el-table tbody td {
  height: 31px;
  padding: 0 !important;
}

.kit-material-workbench ::v-deep .el-table tbody .cell {
  color: var(--foreground);
  font-size: var(--font-size-body);
  height: 31px;
  line-height: 31px;
  padding-left: 8px;
  padding-right: 8px;
  box-sizing: border-box;
}

/* 采购状态文字色与订单页一致，作用于主表和左右固定列。 */
.kit-material-workbench ::v-deep .net-material-table tr.table-body-cell-class1 .cell,
.kit-material-workbench ::v-deep .net-material-table tr.status-unknown .cell { color: #909399; }
.kit-material-workbench ::v-deep .net-material-table tr.table-body-cell-blue .cell { color: #409eff; }
.kit-material-workbench ::v-deep .net-material-table tr.table-body-cell-green .cell { color: #67c23a; }
.kit-material-workbench ::v-deep .net-material-table tr.table-body-cell-yellow .cell { color: #e6a23c; }
.kit-material-workbench ::v-deep .net-material-table tr.table-body-cell-red .cell { color: #f56c6c; }

.kit-material-workbench ::v-deep .el-table tbody .cell .el-tag {
  height: 20px;
  line-height: 18px;
  padding: 0 6px;
}

.kit-material-workbench ::v-deep .el-table tbody .cell .shadcn-button,
.kit-material-workbench ::v-deep .el-table tbody .cell .el-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  line-height: 20px;
  padding: 0 6px;
  white-space: nowrap;
}

.kit-material-workbench ::v-deep .el-table tbody .cell .el-checkbox {
  height: 16px;
  line-height: 16px;
}

.kit-material-workbench ::v-deep .el-table tbody .cell .readiness-cell,
.kit-material-workbench ::v-deep .el-table tbody .cell .material-name {
  height: 31px;
}

.kit-material-workbench ::v-deep .el-table thead th {
  height: 32px;
  padding: 0 !important;
  vertical-align: middle;
  background: #fff !important;
}

.kit-material-workbench ::v-deep .el-table thead th .cell {
  height: 31px;
  padding-left: 0;
  padding-right: 0;
  line-height: 31px;
  white-space: nowrap;
  box-sizing: border-box;
}

.kit-material-workbench ::v-deep .summary-table thead tr:first-child th {
  height: 24px;
  padding: 0 !important;
  background: #fff !important;
}

.kit-material-workbench ::v-deep .summary-table thead tr:first-child th:not([rowspan="2"]) .cell {
  height: 24px;
  line-height: 24px;
}

.kit-material-workbench ::v-deep .summary-header-filter {
  display: block;
  width: calc(100% - 8px) !important;
  height: 18px;
  margin: 1px 4px;
}

.kit-material-workbench ::v-deep .summary-header-filter .el-input__inner {
  height: 18px;
  padding: 0 16px 0 3px;
  color: var(--foreground);
  border: 0;
  border-bottom: 1px solid transparent;
  border-radius: 0;
  background: transparent;
  font-size: var(--font-size-body);
  line-height: 18px;
}

.kit-material-workbench ::v-deep .summary-header-filter .el-input__inner:hover,
.kit-material-workbench ::v-deep .summary-header-filter .el-input__inner:focus {
  border-bottom-color: #7d9eea;
}

.kit-material-workbench ::v-deep .summary-header-filter .el-input__prefix,
.kit-material-workbench ::v-deep .summary-header-filter .el-input__suffix,
.kit-material-workbench ::v-deep .summary-header-filter .el-input__icon {
  height: 18px;
  line-height: 18px;
}

.kit-material-workbench ::v-deep .summary-header-filter .el-input__prefix {
  left: 2px;
}

.kit-material-workbench ::v-deep .summary-header-filter .el-input__suffix {
  right: 1px;
}

.kit-material-workbench ::v-deep .summary-header-filter.el-date-editor .el-input__inner {
  padding-left: 17px;
}

.kit-material-workbench ::v-deep .summary-header-filter.el-input-number .el-input-number__decrease,
.kit-material-workbench ::v-deep .summary-header-filter.el-input-number .el-input-number__increase {
  display: none;
}

.kit-material-workbench ::v-deep .summary-header-filter.el-input-number .el-input__inner {
  padding: 0 3px;
  text-align: left;
}

.kit-material-workbench ::v-deep .el-table thead th,
.kit-material-workbench ::v-deep .el-table thead th .cell {
  font-weight: var(--font-weight-table-header);
  font-size: var(--font-size-table-header);
  color: var(--foreground);
}

.kit-material-workbench ::v-deep .el-input__inner,
.kit-material-workbench ::v-deep .el-textarea__inner,
.kit-material-workbench ::v-deep .el-form-item__label,
.kit-material-workbench ::v-deep .el-radio__label,
.kit-material-workbench ::v-deep .el-checkbox__label {
  color: var(--foreground);
  font-size: var(--font-size-body);
}

.kit-material-workbench ::v-deep .el-table__empty-text,
.kit-material-workbench ::v-deep .el-input__inner::placeholder,
.kit-material-workbench ::v-deep .el-textarea__inner::placeholder {
  color: var(--muted-foreground);
  font-size: var(--font-size-hint);
  opacity: 1;
}

.kit-material-workbench ::v-deep .summary-filter-reset.el-button {
  position: static;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin: 0 auto;
  padding: 0;
  color: var(--muted-foreground);
  background: transparent;
  border: 0;
  line-height: 16px;
}
.kit-material-workbench ::v-deep .summary-filter-reset.el-button:hover,
.kit-material-workbench ::v-deep .summary-filter-reset.el-button:focus {
  color: #f56c6c;
  background: transparent;
}
/* 订单双层表头：标题与查询行分开，固定列副本使用相同尺寸。 */
.kit-material-workbench ::v-deep .summary-table thead tr:nth-child(2) th {
  height: 24px;
  background: #f5f7fa !important;
}
.kit-material-workbench ::v-deep .summary-table thead tr:nth-child(2) .cell {
  height: 24px;
  line-height: 24px;
  overflow: hidden;
}
.kit-material-workbench ::v-deep .summary-table thead tr:first-child th[rowspan="2"] {
  height: 48px;
}
.kit-material-workbench ::v-deep .summary-table .summary-header-filter {
  width: 100% !important;
  height: 24px;
  margin: 0;
}
.kit-material-workbench ::v-deep .summary-table .summary-header-filter .el-input__inner {
  height: 24px;
  line-height: 24px;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 0;
  padding-right: 20px;
  font-weight: 400;
}
.kit-material-workbench ::v-deep .summary-table .summary-header-filter .el-input__inner:hover {
  border-color: #c0c4cc;
}
.kit-material-workbench ::v-deep .summary-table .summary-header-filter .el-input__inner:focus {
  border-color: #409eff;
}
.kit-material-workbench ::v-deep .summary-table .summary-header-filter .el-input__prefix,
.kit-material-workbench ::v-deep .summary-table .summary-header-filter .el-input__suffix,
.kit-material-workbench ::v-deep .summary-table .summary-header-filter .el-input__icon {
  height: 24px;
  line-height: 24px;
}
.kit-material-workbench ::v-deep .summary-table .summary-header-filter .el-input__icon {
  width: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: top;
  line-height: 1;
}
.kit-material-workbench ::v-deep .summary-table .summary-header-filter .el-input__prefix,
.kit-material-workbench ::v-deep .summary-table .summary-header-filter .el-input__suffix,
.kit-material-workbench ::v-deep .summary-table .summary-header-filter .el-input__suffix-inner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  top: 0;
  height: 24px;
}
.kit-material-workbench ::v-deep .summary-table .summary-header-filter .el-input__icon::after {
  display: none;
}
.kit-material-workbench ::v-deep .summary-table .summary-header-filter input[type="number"] {
  -moz-appearance: textfield;
}
.kit-material-workbench ::v-deep .summary-table .summary-header-filter input::-webkit-inner-spin-button,
.kit-material-workbench ::v-deep .summary-table .summary-header-filter input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.kit-material-workbench ::v-deep .summary-table thead th[rowspan="2"]:first-child > .cell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0;
  line-height: normal;
}
.kit-material-workbench ::v-deep .summary-table thead th[rowspan="2"]:first-child .summary-filter-reset {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin: 0;
  line-height: 1;
}
.kit-material-workbench ::v-deep .summary-table thead th[rowspan="2"]:first-child .summary-filter-reset .el-icon-delete-solid {
  display: block;
  width: 18px;
  height: 18px;
  font-size: 18px !important;
  line-height: 18px;
}
</style>
